import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';

import axios from 'axios';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import DropZone from 'components/Shared/DropZone';
import EnvoiMailServiceAchat from '../EnvoiMailServiceAchat';
import Fichier from 'components/Shared/Fichier';
import ColisLogistiquePhoto from 'components/Shared/ColisLogistiquePhoto';

import LigneGestionQualification from 'components/Shared/LigneGestionQualification';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';
import { GarantieType } from 'constants.js';
import { PerimetresSAV } from 'constants.js';

import { TypeCodes } from 'constants.js';


import LocalisationProduit from '../QualificationComponents/LocalisationProduit';
import PriseEnCharge from '../QualificationComponents/PriseEnCharge';
import FicheRetourFournisseur from '../QualificationComponents/FicheRetourFournisseur';
import PropositionAchat from '../QualificationComponents/PropositionAchat';
import AcceptationSAV from '../QualificationComponents/AcceptationSAV';
import DepannageDirectClient from '../QualificationComponents/DepannageDirectClient';

import SavByFoussierConcerne from '../QualificationComponents/SavByFoussierConcerne';
import SavByFoussierProduit from '../QualificationComponents/SavByFoussierProduit';
import SavByFoussierExtensionGarantie from '../QualificationComponents/SavByFoussierExtensionGarantie';
import SavByFoussierGarantieCalculee from '../QualificationComponents/SavByFoussierGarantieCalculee';

import SavByFoussierPriseEnCharge from '../QualificationComponents/SavByFoussierPriseEnCharge';
import SavByFoussierRestitution from '../QualificationComponents/SavByFoussierRestitution';
import SavByFoussierBonTransport from '../QualificationComponents/SavByFoussierBonTransport';
import SavByFoussierRenvoi from '../QualificationComponents/SavByFoussierRenvoi';
import SavByFoussierPreuveAchat from '../QualificationComponents/SavByFoussierPreuveAchat';

import SavHorsGarantieMajorationDialog from '../QualificationComponents/SavHorsGarantieMajorationDialog';

import MessageDialog from 'components/Shared/MessageDialog';
import QualificationAccordionSummary from '../QualificationComponents/QualificationAccordionSummary';

import qualificationHelper from 'utils/qualificationHelper';
import localStorageHelper from 'utils/localStorageHelper';
import dateHelper from 'utils/dateHelper';
import { reclamationSoumiseQuantiteRetournable } from 'utils/quantiteRetournableHelper';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    },

    link: theme.style.link,

    fieldset: {
        flexBasis: '100%',
        marginBottom: '10px',

        marginLeft: '2px',
        marginRight: '2px',
        paddingTop: '0.35em',
        paddingBottom: '0.625em',
        paddingLeft: '0.75em',
        paddingRight: '0.75em',
        border: '1px solid ' + theme.palette.primary.main + ''
    },

    bonRetourImprime: {
        backgroundColor: theme.palette.primary.main
    },
    bonRetourNonImprime: {
        backgroundColor: theme.palette.secondary[500]
    },

    bold: {
        fontWeight: 'bold'
    },


    leftIcon: {
        marginRight: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    },

    marginRight: {
        marginRight: theme.spacing(1)
    },
});

/* Liste des réponses possibles */
const etatProduitLabel = "Quel est l'état du produit ? ";
const etatsProduit = [
    "Le produit est neuf, non monté et non utilisé.",
    "Le produit est déja utilisé ou monté."
];

const achatInitialFoussierLabel = "S'agit-il d'un achat initial chez Foussier ?";

const clientInformeLabel = "Le client a été informé des conditions de reprise";
const priseConnaissanceDemarcheLabel = "J'ai bien pris connaissance de la démarche";


const garantieProduitLabel = "S'agit-il d'un produit ";
const garantiesProduit = [
    "Sous Garantie (ou extension de garantie)",
    "Hors Garantie"
];


const memoCloture = `Ce dossier après-vente concerne un article déjà utilisé ou déjà monté et non plus un défaut non monté à la première utilisation.
Le service Qualité Entrepôt ne peut pas prendre en charge cette demande.
Il s'agit d'une demande de SAV, merci de contacter le fournisseur ou d'orienter le client vers le magasin le plus proche.`;

const warningNbLignes = `Un seul article est autorisé sur cette qualification.

Pour un autre article défaut produit, merci de procéder à une nouvelle saisie`;

const warningZeroLigne = 'Veuillez sélectionner une ligne article.';

const attacherBonRetourFormat = `Attacher les conditions de reprise défaut produit en pièce jointe au mail de notification client envoyé à : {0}`;


const seuilRentabiliteReparationSousGarantie = 50;
const seuilRentabiliteReparationHorsGarantie = 200;
const superieurSeuilRentabiliteReparationFormat = `Le montant de l'article est-il supérieur à {0} euro ?`;


const extensionGarantieLabel = "L'article fait-il l'objet d'une extension de garantie ?";


const poursuivreHorsGarantieNonAchatFoussierLabel = "Le montant des réparations sera supérieur à la valeur de l'article, souhaitez-vous poursuivre ?";
const poursuivreHorsGarantieAchatFoussierLabel = "Le prix de vente de l'article est inférieur au montant de 200 euro demandé pour le traitement d'un SAV, souhaitez-vous poursuivre ?";


const depannageClientLabel = "Dépanner le client en réalisant : ";
const depannagesClient = [
    "un avoir et une regul de stock",
    "un avoir / refacturation et regul de stock",
    "un avoir et une regul de stock et un depart plateforme",
    "un gratuit",
];


/* Liste des réponses possibles */
const photoConsulteeLabel = "Avez-vous pris connaissance de la photo ? ";
const photoConsulteeLabels = [
    "Oui, j'ai trouvé les informations souhaitées et tout est conforme (dossier après-vente clôturé automatiquement).",
    "Oui, mais je souhaite créer le dossier après-vente"
];



// Regles de validation à passer en paramètre de qualificationHelper.getErrors
// La fonction d'assertion renvoi true quand la règle est respectée
const _rules = [
    {
        key: ReclamationQualificationDetailCodes.AchatInitialFoussier,
        errorMsg: achatInitialFoussierLabel,
        fields: 'achatInitialFoussier',
        assertion: function (a) { return a !== undefined && a !== null && a !== '' }
    },
    {
        key: ReclamationQualificationDetailCodes.GarantieProduit,
        errorMsg: garantieProduitLabel,
        fields: ['achatInitialFoussier', 'garantieProduit'],
        assertion: function (a) {
            if (a[0] === false) {
                return a[1] !== undefined && a[1] !== '';
            }
            return true;
        }
    },

    // Règle pour le seuil nonAchatInitial / sous-garantie
    {
        key: ReclamationQualificationDetailCodes.SeuilRentabiliteReparationAtteint + '_' + seuilRentabiliteReparationSousGarantie,
        errorMsg: superieurSeuilRentabiliteReparationFormat.replace("{0}", seuilRentabiliteReparationSousGarantie),
        fields: ['achatInitialFoussier', 'garantieProduit', 'seuilRentabiliteReparationAtteint'],
        assertion: function (a) {
            if (a[0] === false && a[1] === 0) {
                return a[2] !== undefined && a[2] !== null;
            }
            return true;
        }
    },

    // Règle pour le seuil nonAchatInitial / hors-garantie
    {
        key: ReclamationQualificationDetailCodes.SeuilRentabiliteReparationAtteint + '_' + seuilRentabiliteReparationHorsGarantie,
        errorMsg: superieurSeuilRentabiliteReparationFormat.replace("{0}", seuilRentabiliteReparationHorsGarantie),
        fields: ['achatInitialFoussier', 'garantieProduit', 'seuilRentabiliteReparationAtteint', 'nePasSelectionnerDePiece'],
        assertion: function (a) {
            if ((!a[0] && a[1] === 1) || (a[0] && a[3])) {
                return a[2] !== undefined && a[2] !== null;
            }
            return true;
        }
    },

    // Ajout de la regle pour la proposition d'achat
    {
        key: ReclamationQualificationDetailCodes.Poursuivre,
        errorMsg: poursuivreHorsGarantieAchatFoussierLabel,
        fields: ['achatInitialFoussier', 'garantieProduit', 'seuilRentabiliteReparationAtteint', 'poursuivre', 'nePasSelectionnerDePiece'],
        assertion: function (a) {
            if ((!a[0] && a[1] === 1 && !a[2]) || (a[0] && !a[2] && a[4])) {
                return a[3] !== undefined && a[3] !== null;
            }
            return true;
        }
    },
    {
        key: ReclamationQualificationDetailCodes.Piece,
        errorMsg: 'Veuillez sélectionner une pièce.',
        fields: ['achatInitialFoussier', 'numeroPiece', 'nePasSelectionnerDePiece'],
        assertion: function (a) {
            if (a[0] && !a[2]) {
                return a[1].length > 0;
            }
            return true;
        }
    },
    {
        // On rajoute '_DEFAUT_PRODUIT' car ReclamationQualificationDetailCodes.NbLignes est supprimé des errors, et ça pose problème dans ce cas.
        key: ReclamationQualificationDetailCodes.Piece + '_DEFAUT_PRODUIT',
        errorMsg: 'Une ligne doit être renseignée.',
        fields: ['achatInitialFoussier', 'lignes', 'nePasSelectionnerDePiece'],
        assertion: function (a) {
            if (a[0] && !a[2]) {
                return a[1].length === 1;
            }
            return true;
        }
    },
    {
        key: ReclamationQualificationDetailCodes.EtatProduit,
        errorMsg: etatProduitLabel,
        fields: ['achatInitialFoussier', 'etatProduit', 'nePasSelectionnerDePiece'],
        assertion: function (a) {
            if (a[0] && !a[2]) {
                return a[1] !== undefined && a[1] !== '';
            }
            return true;
        }
    },
    {
        key: 'RETOURNABLE_DEPASSE',
        errorMsg: "La quantité déclarée dépasse la quantité retournable. Veuillez la corriger.",
        fields: ['etatProduit', 'lignes', 'soumisQuantiteRetournable'],
        assertion: function (a) {
            if (a[0] === 0 && a[2]) {
                return !a[1].some(l => l.quantiteRetournable !== undefined && l.quantiteRetournable !== null
                    && Number(l.quantiteAnomalie) > l.quantiteRetournable);
            }
            return true;
        }
    },
    {
        key: ReclamationQualificationDetailCodes.ClientInforme,
        errorMsg: 'Veuillez confirmer que le client a été informé.',
        fields: ['achatInitialFoussier', 'livraisonDirecte', 'rapido', 'lignes', 'clientInforme', 'etatProduit', 'reclamationTypeCession'],
        assertion: function (a) {
            if (a[0] && !a[6] && a[5] === 0 && !a[1] && !a[2] && a[3].length === 1 && a[3][0].marqueExclusive) {
                return a[4];
            }
            return true;
        }
    },
    {
        key: 'BON_RETOUR_IMPRIMER_OU_ATTACHER',
        errorMsg: "Veuillez imprimer le bon de retour ou demander de l'attacher dans le mail de notification au client",
        fields: ['achatInitialFoussier', 'livraisonDirecte', 'rapido', 'lignes', 'suiviEmail', 'bonRetourImprime', 'attacherBonRetour', 'etatProduit', 'reclamationTypeCession'],
        assertion: function (a) {
            if (a[0] && !a[8] && a[7] === 0 && !a[1] && !a[2] && a[3].length === 1 && a[3][0].marqueExclusive && a[4]) {
                return a[5] || a[6];
            }
            return true;
        }
    },
    {
        key: 'BON_RETOUR_IMPRIMER',
        errorMsg: 'Veuillez imprimer le bon de retour',
        fields: ['achatInitialFoussier', 'livraisonDirecte', 'rapido', 'lignes', 'suiviEmail', 'bonRetourImprime', 'etatProduit'],
        assertion: function (a) {
            if (a[0] && a[6] === 0 && !a[1] && !a[2] && a[3].length === 1 && a[3][0].marqueExclusive && !a[4]) {
                return a[5];
            }
            return true;
        }
    },

    {
        key: 'suiviTelephoneMobile',
        errorMsg: 'Veuillez saisir le numéro de téléphone du contact',
        fields: ['savByFoussierConcerne', 'suiviTelephoneMobile'],
        assertion: function (a) {
            if (a[0] !== undefined && a[0] !== null && a[0] !== '') {
                return a[1] !== undefined && a[1] !== '';
            }
            return true;
        }
    },
    {
        key: 'suiviNomContact',
        errorMsg: 'Veuillez saisir le nom du contact',
        fields: ['savByFoussierConcerne', 'suiviNomContact'],
        assertion: function (a) {
            if (a[0] !== undefined && a[0] !== null && a[0] !== '') {
                return a[1] !== undefined && a[1] !== '';
            }
            return true;
        }
    },
    {
        key: 'suiviEmail',
        errorMsg: 'Veuillez saisir le mail',
        fields: ['savByFoussierConcerne', 'suiviEmail'],
        assertion: function (a) {
            if (a[0] !== undefined && a[0] !== null && a[0] !== '') {
                return a[1] !== undefined && a[1] !== '';
            }
            return true;
        }
    },



    // Règle pour la consultation de la photo
    {
        key: ReclamationQualificationDetailCodes.PhotoConsultee,
        errorMsg: photoConsulteeLabel,
        fields: ['achatInitialFoussier', 'etatProduit', 'nePasSelectionnerDePiece', 'lignes', 'colisLogistiques', 'photoConsultee'],

        assertion: function (a) {
            if (a[0] && (a[1] === 0) && !a[2] && a[3].length > 0 && a[4].length > 0) {

                let reclaCodes = a[3].map(x => x.codeArticle);

                let colisLogistiquesPhoto = a[4].map(x => {

                    let codesArticles = x.lignes.map(x => x.codeArticle);
                    let c = {
                        photoId: x.photoId,
                        numeroSupport: x.numeroSupport,
                        concerneRecla: reclaCodes.some(r => codesArticles.indexOf(r) >= 0)
                    };
                    return c;
                });

                let afficherQuestion = colisLogistiquesPhoto.some(x => x.concerneRecla && x.photoId);


                if (afficherQuestion) {
                    return a[5] !== undefined && a[5] !== '';
                } else {
                    return true;
                }
            }
            return true;
        }
    },

    // Règle DepannageClient
    {
        key: ReclamationQualificationDetailCodes.DepannageClient,
        errorMsg: depannageClientLabel,
        fields: ['etatProduit', 'depannageClient', 'delaiGarantieProduit', 'savByFoussierConcerne'],
        assertion: function (a) {
            if (a[0] !== undefined && a[0] === 1 && a[3] === undefined) {
                return (a[2] !== '' && a[2] > 9998) || (a[1] !== undefined && a[1] !== '');
            }
            return true;
        }
    }


];


class DefautProduitSAVAutoriseStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece',
        bonRetourImprime: false,
        alerteRetournableOpen: false,
        mountedSubComponents: [],
        unMountedSubComponents: [],
        mountedSubComponentsError: [],

        erreurPreuveDAChat: false,
        erreurConditionsSAV: false,
        sendMailServiceAchat: {
            open: false,
            fournisseur: null
        }
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        const nextStepValid = reclamation.numeroPiece.length > 0 && reclamation.lignes.length > 0;

        onNextStepValid(nextStepValid);
    }


    rules = (newState) => {

        let currentState = newState ? newState : this.state;

        let newRules = [..._rules];
        for (let i in currentState.mountedSubComponents) {
            let name = currentState.mountedSubComponents[i];

            newRules.push(
                {
                    key: name,
                    errorMsg: `Erreur(s) dans le sous-composant: ${name}`,
                    fields: ['mountedSubComponentsError'],
                    assertion: function (a) {
                        return !a[0] || !a[0].find(x => x === name);
                    }
                });
        }
        // Pas d'erreur dans les sous-composants démontés
        for (let i in currentState.unMountedSubComponents) {
            let name = currentState.unMountedSubComponents[i];

            newRules.push(
                {
                    key: name,
                    errorMsg: ``,
                    fields: ['mountedSubComponents'],
                    assertion: function (a) {
                        return true;
                    }
                });
        }
        return newRules;
    }

    //#region Getters

    getEtatProduit = () => {
        const { reclamation } = this.props;

        let etatProduit = '';

        const detailEtatProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.EtatProduit);
        if (detailEtatProduit !== undefined) {
            etatProduit = detailEtatProduit.valeurInteger;
        }

        return etatProduit;
    }

    getDepannageClient = () => {
        const { reclamation } = this.props;

        let depannageClient = '';

        const detailDepannageClient = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.DepannageClient);
        if (detailDepannageClient !== undefined) {
            depannageClient = detailDepannageClient.valeurInteger;
        }

        return depannageClient;
    }


    getTempsUsageProduit = () => {
        const { reclamation } = this.props;

        let tempsUsageProduit = '';

        const detailTempsUsageProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.TempsUsageProduit);
        if (detailTempsUsageProduit !== undefined) {
            tempsUsageProduit = detailTempsUsageProduit.valeurString;
        }

        return tempsUsageProduit;
    }

    getNbUtilisationProduit = () => {
        const { reclamation } = this.props;

        let nbUtilisationProduit = '';

        const detailNbUtilisationProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.NbUtilisationProduit);
        if (detailNbUtilisationProduit !== undefined) {
            nbUtilisationProduit = detailNbUtilisationProduit.valeurInteger;
        }

        return nbUtilisationProduit;
    }

    getAchatInitialFoussier = () => {
        const { reclamation } = this.props;

        let achatInitialFoussier = null;

        const detailAchatInitialFoussier = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.AchatInitialFoussier);
        if (detailAchatInitialFoussier !== undefined) {
            achatInitialFoussier = Boolean(detailAchatInitialFoussier.valeurBool);
        }

        return achatInitialFoussier;
    }

    getPoursuivre = () => {
        const { reclamation } = this.props;

        let poursuivre = null;

        const detailPoursuivre = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.Poursuivre);
        if (detailPoursuivre !== undefined) {
            poursuivre = Boolean(detailPoursuivre.valeurBool);
        }

        return poursuivre;
    }

    getAcceptationSAV = () => {
        const { reclamation } = this.props;

        let acceptationSAV = null;

        const detailAcceptationSAV = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.AcceptationSAV);
        if (detailAcceptationSAV !== undefined) {
            acceptationSAV = Boolean(detailAcceptationSAV.valeurBool);
        }

        return acceptationSAV;
    }

    getExtensionGarantie = () => {
        const { reclamation } = this.props;

        let extensionGarantie = null;

        const detailExtensionGarantie = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.ExtensionGarantie);
        if (detailExtensionGarantie !== undefined) {
            extensionGarantie = Boolean(detailExtensionGarantie.valeurBool);
        }

        return extensionGarantie;
    }

    getGarantieProduit = () => {
        const { reclamation } = this.props;

        let garantieProduit = '';

        const detailGarantieProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.GarantieProduit);
        if (detailGarantieProduit !== undefined) {
            garantieProduit = detailGarantieProduit.valeurInteger;
        }

        return garantieProduit;
    }

    getDelaiGarantieProduit = () => {
        const { reclamation } = this.props;

        let delaiGarantieProduit = '';

        const detailDelaiGarantieProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.DelaiGarantie);
        if (detailDelaiGarantieProduit !== undefined) {
            delaiGarantieProduit = detailDelaiGarantieProduit.valeurInteger;
        }

        return delaiGarantieProduit;
    }

    getInfosGarantie = (lignes) => {
        const { reclamation, agePiece } = this.props;

        // console.log("getInfosGarantie, lignes", lignes);

        let conditionSAV = null;
        let fournisseurLibelle = '';
        let fournisseur = lignes ? lignes[0].fournisseur : reclamation.lignes[0].fournisseur;

        if (fournisseur) {

            fournisseurLibelle = fournisseur.code + ' - ' + fournisseur.nom;

            if (fournisseur.infosSAV) {

                conditionSAV = fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                if (!conditionSAV) {
                    conditionSAV = fournisseur.infosSAV.conditionsSAVSousFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                    if (!conditionSAV) {
                        conditionSAV = fournisseur.infosSAV.conditionsSAVFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                        if (!conditionSAV) {
                            conditionSAV = fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                            if (conditionSAV) {
                                conditionSAV.source = 'generale';
                            }

                        }
                        else {
                            conditionSAV.source = 'famille';
                        }

                    }
                    else {
                        conditionSAV.source = 'sous-famille';
                    }
                }
                else {
                    conditionSAV.source = 'article';
                }

            }


        }

        //console.log("getInfosGarantie, fournisseur.infosSAV", fournisseur.infosSAV);
        //console.log("getInfosGarantie, conditionSAV", conditionSAV);

        if (!conditionSAV) {
            conditionSAV = {
                source: 'defaut',
                garantieType: GarantieType.SousGarantieApresUtilisation,
                delaiReference: 365,
                //delaiExtensionGarantie: null,
                //ficheRetourFournisseur: { id: 0 }
            }
        }


        // On utilise valeurUnitaire au lieu de prixUnitaire pour prendre en compte la valeur des composants
        let montant = lignes ? lignes[0].valeurUnitaire * lignes[0].quantiteAnomalie : reclamation.lignes[0].valeurUnitaire * reclamation.lignes[0].quantiteAnomalie;

        let sousGarantie = (agePiece <= conditionSAV.delaiReference);
        let sousExtensionGarantie = conditionSAV.delaiExtensionGarantie !== null && conditionSAV.delaiExtensionGarantie > 0 && (agePiece <= conditionSAV.delaiExtensionGarantie); // TODO test sur le GSG 51


        let result = {
            montant: montant,
            sousGarantie: sousGarantie,
            sousExtensionGarantie: sousExtensionGarantie,
            fichierId: conditionSAV.ficheRetourFournisseur ? conditionSAV.ficheRetourFournisseur.id : 0,
            fournisseurLibelle: fournisseurLibelle,
            delai: sousGarantie ? conditionSAV.delaiReference : (sousExtensionGarantie ? conditionSAV.delaiExtensionGarantie : ''),
            source: conditionSAV.source
        };

        console.log("getInfosGarantie", result);

        return result;
    }

    getInfosExtensionGarantie = () => {
        const { reclamation, agePiece } = this.props;

        let fournisseur = reclamation.lignes[0].fournisseur;
        let conditionSAV = null;

        if (fournisseur.infosSAV) {

            conditionSAV = fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

            if (!conditionSAV) {
                conditionSAV = fournisseur.infosSAV.conditionsSAVSousFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
            }

            if (!conditionSAV) {
                conditionSAV = fournisseur.infosSAV.conditionsSAVFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
            }

            if (!conditionSAV) {
                conditionSAV = fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
            }
        }


        let montant = reclamation.lignes[0].valeurUnitaire * reclamation.lignes[0].quantiteAnomalie;

        let sousExtensionGarantie = conditionSAV && conditionSAV.delaiExtensionGarantie !== null && conditionSAV.delaiExtensionGarantie > 0 && (agePiece <= conditionSAV.delaiExtensionGarantie);


        let result = {
            montant: montant,
            sousExtensionGarantie: sousExtensionGarantie,
            fichierId: conditionSAV.ficheRetourFournisseur,
            extensionGarantie: this.getExtensionGarantie(),
            delaiExtensionGarantie: conditionSAV && conditionSAV.delaiExtensionGarantie ? conditionSAV.delaiExtensionGarantie : '',
            delaiReference: conditionSAV.delaiReference
        };

        return result;
    }

    getSeuilRentabiliteReparationAtteint = () => {
        const { reclamation } = this.props;

        let seuilRentabiliteReparationAtteint = null;

        const detailSeuilRentabiliteReparationAtteint = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.SeuilRentabiliteReparationAtteint);
        if (detailSeuilRentabiliteReparationAtteint !== undefined) {
            seuilRentabiliteReparationAtteint = detailSeuilRentabiliteReparationAtteint.valeurBool;
        }

        return seuilRentabiliteReparationAtteint;
    }


    getClientInforme = () => {
        const { reclamation } = this.props;

        let clientInforme = false;

        const detailClientInforme = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.ClientInforme);
        if (detailClientInforme !== undefined) {
            clientInforme = detailClientInforme.valeurBool;
        }

        return clientInforme;
    }

    getPriseConnaissanceDemarche = () => {
        const { reclamation } = this.props;

        let priseConnaissanceDemarche = false;

        const detailPriseConnaissanceDemarche = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.PriseConnaissanceDemarche);
        if (detailPriseConnaissanceDemarche !== undefined) {
            priseConnaissanceDemarche = detailPriseConnaissanceDemarche.valeurBool;
        }

        return priseConnaissanceDemarche;
    }


    getFournisseur = () => {
        const { reclamation } = this.props;

        let fournisseur = null;

        const detailFournisseur = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.Fournisseur);
        if (detailFournisseur !== undefined) {
            //fournisseur = detailFournisseur.valeurInteger;
            fournisseur = detailFournisseur.valeurObject;
        }

        return fournisseur;
    }


    getAfficheMemoCloture = () => {
        const { reclamation, livraisonDirecte, rapido } = this.props;

        var etatProduit = this.getEtatProduit();

        let afficheMemoCloture = false;

        if (etatProduit === 1 && !livraisonDirecte && !rapido && reclamation.lignes && reclamation.lignes.length === 1) {
            afficheMemoCloture = !reclamation.lignes[0].marqueExclusive && !reclamation.lignes[0].autoriseSAVPlateformeLogistique;

        }

        return afficheMemoCloture;
    }

    getAttacherBonRetour = () => {
        const { reclamation } = this.props;

        let attacherBonRetour = false;

        const detailAttacherBonRetour = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.AttacherBonRetour);
        if (detailAttacherBonRetour !== undefined) {
            attacherBonRetour = detailAttacherBonRetour.valeurBool;
        }

        return attacherBonRetour;
    }


    getLocalisationProduit = () => {
        const { reclamation } = this.props;

        let localisationProduit = false;

        const detailLocalisationProduit = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.LocalisationProduit);
        if (detailLocalisationProduit !== undefined) {
            localisationProduit = detailLocalisationProduit.valeurInteger;
        }

        return localisationProduit;
    }

    getSituationArticle = () => {
        const { reclamation } = this.props;

        let situationArticle = false;

        const detailSituationArticle = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.SituationArticle);
        if (detailSituationArticle !== undefined) {
            situationArticle = detailSituationArticle.valeurInteger;
        }

        return situationArticle;
    }


    getDetail = (code, typeValeur) => {
        const { reclamation } = this.props;

        let result = '';

        const detail = reclamation.qualificationDetails.find(detail => detail.code === code);
        if (detail !== undefined) {
            result = detail[typeValeur];
        }

        //console.log("getDetail", code, typeValeur, detail, result);

        return result;
    }

    // Génére un tableau des champs à controler. Un champ peut être mis à jour par rapport aux valeur par défaut.
    depasseQuantiteRetournable = () => {
        const { reclamation } = this.props;
        return reclamationSoumiseQuantiteRetournable(reclamation)
            && reclamation.lignes.some(l => l.quantiteRetournable !== undefined && l.quantiteRetournable !== null
                && Number(l.quantiteAnomalie) > l.quantiteRetournable);
    }

    getToCheck(champ, valeur) {
        const { reclamation, utilisateurMagasin, livraisonDirecte, rapido, colisLogistiques } = this.props;

        let result = {
            etatProduit: this.getEtatProduit(),
            tempsUsageProduit: this.getTempsUsageProduit(),
            nbUtilisationProduit: this.getNbUtilisationProduit(),
            priseConnaissanceDemarche: this.getPriseConnaissanceDemarche(),
            clientInforme: this.getClientInforme(),
            attacherBonRetour: this.getAttacherBonRetour(),
            achatInitialFoussier: this.getAchatInitialFoussier(),
            garantieProduit: this.getGarantieProduit(),
            delaiGarantieProduit: this.getDelaiGarantieProduit(),

            poursuivre: this.getPoursuivre(),

            lignes: [...reclamation.lignes],
            bonRetourImprime: this.state.bonRetourImprime,

            numeroPiece: reclamation.numeroPiece,
            livraisonDirecte: livraisonDirecte,
            rapido: rapido,

            seuilRentabiliteReparationAtteint: this.getSeuilRentabiliteReparationAtteint(),
            depannageClient: this.getDepannageClient(),

            utilisateurMagasin: utilisateurMagasin,
            reclamationTypeClient: reclamation.type.code === TypeCodes.Client,
            reclamationTypeCession: reclamation.type.code === TypeCodes.Cession,
            soumisQuantiteRetournable: reclamationSoumiseQuantiteRetournable(reclamation),

            mountedSubComponentsError: this.state.mountedSubComponentsError,

            suiviNomContact: reclamation.suiviNomContact,
            suiviTelephoneMobile: reclamation.suiviTelephoneMobile,
            suiviEmail: reclamation.suiviEmail,

            anonyme: localStorageHelper.isAnonymous(),

            savByFoussierConcerne: this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierConcerne, 'valeurInteger'),

            // savByFoussier sert uniquement pour achat foussier dans les tests. Sinon vérifier avec this.getFournisseur()
            savByFoussier: reclamation.lignes.length > 0 && reclamation.lignes[0].fournisseur && reclamation.lignes[0].fournisseur.infosSAV && reclamation.lignes[0].fournisseur.infosSAV.savByFoussier,

            nePasSelectionnerDePiece: !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool'),


            photoConsultee: this.getDetail(ReclamationQualificationDetailCodes.PhotoConsultee, 'valeurInteger'),
            colisLogistiques: colisLogistiques
        }

        console.log('getToCheck', result);

        if (champ) {
            result[champ] = valeur;
        }
        return result;

    }

    //#endregion Getters 

    //#region Handlers

    handleChangeOnSubComponent = (name, position, toAdd, toDelete, when) => {

        const { onDetailChange } = this.props;

        this.setState((state, props) => {

            //console.log("changing details on subcomponent", { name, position, toAdd, toDelete, when });

            let newState = { ...state };
            if (when === "Mount") {
                if (!newState.mountedSubComponents.find(x => x === name)) {
                    newState.mountedSubComponents.push(name);
                }
                newState.unMountedSubComponents = newState.unMountedSubComponents.filter(x => x !== name);
            }
            if (when === "Unmount") {
                newState.mountedSubComponents = newState.mountedSubComponents.filter(x => x !== name);
                newState.mountedSubComponentsError = newState.mountedSubComponentsError.filter(x => x !== name);

                if (!newState.unMountedSubComponents.find(x => x === name)) {
                    newState.unMountedSubComponents.push(name);
                }
            }

            if (when === "Mount" || when === "Life") {

                if (toAdd !== null) {
                    newState.mountedSubComponentsError = newState.mountedSubComponentsError.filter(x => x !== name);
                }
                else {
                    if (!newState.mountedSubComponentsError.find(x => x === name)) {
                        newState.mountedSubComponentsError.push(name);
                    }
                }
            }

            //console.log('mountedSubComponents', newState.mountedSubComponents);
            //console.log('mountedSubComponentsError', newState.mountedSubComponentsError);

            return newState;
        }, () => { onDetailChange(toAdd, qualificationHelper.getErrors(this.getToCheck(), this.rules()), toDelete); });

    }


    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            expandedPanel: expandedPanel ? panel : false
        });
    }

    handleChange = (event) => {
        const { onChange } = this.props;

        //console.log("handleChange event.target.name", event.target.name);
        //console.log("handleChange event.target.value", event.target.value);


        let toCheckValue = this.getToCheck(event.target.name, event.target.value);
        const errors = qualificationHelper.getErrors(toCheckValue, this.rules());

        //console.log("handleChange toCheckValue", toCheckValue);


        //console.log("handleChange this.getToCheck()", this.getToCheck());
        //console.log("handleChange this.rules()", this.rules());

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece, genererPDF } = this.props;

        // On ouvre le panel avec les lignes de la pièce.
        this.setState({
            expandedPanel: 'panelLignes'
        });

        // On appelle le WiService de génération du fichier pdf pour la pièce sélectionnée.
        genererPDF(value);

        onSelectPiece(value, qualificationHelper.getErrors(this.getToCheck(), this.rules()), true);
    }


    handleQualificationDetailsEtatProduitChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.EtatProduit,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: etatProduitLabel,
            valeurString: etatsProduit[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        };

        let detailsToDelete = [];
        let errors = [];
        if (event.target.value === '0') {
            detailsToDelete.push(ReclamationQualificationDetailCodes.TempsUsageProduit);
            detailsToDelete.push(ReclamationQualificationDetailCodes.NbUtilisationProduit);
            detailsToDelete.push(ReclamationQualificationDetailCodes.PriseConnaissanceDemarche);

            let valueToCheck = this.getToCheck();
            valueToCheck.etatProduit = qualificationDetail.valeurInteger;
            valueToCheck.tempsUsageProduit = null;
            valueToCheck.nbUtilisationProduit = null;
            valueToCheck.priseConnaissanceDemarche = null;

            errors = qualificationHelper.getErrors(valueToCheck, this.rules());

            if (this.depasseQuantiteRetournable()) {
                this.setState({ alerteRetournableOpen: true });
            }
        }
        else {

            detailsToDelete.push(ReclamationQualificationDetailCodes.PhotoConsultee);

            let valueToCheck = this.getToCheck();
            valueToCheck.etatProduit = qualificationDetail.valeurInteger;

            errors = qualificationHelper.getErrors(valueToCheck, this.rules());
        }

        onDetailChange(qualificationDetail, errors, detailsToDelete);
    }

    handleQualificationDetailsDepannageClientChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.DepannageClient,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: depannageClientLabel,
            valeurString: depannagesClient[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        };

        onDetailChange(qualificationDetail, qualificationHelper.getErrors(this.getToCheck('depannageClient', event.target.value), this.rules()), null);
    }


    handleQualificationDetailsAchatInitialFoussierChange = (event) => {
        const { onDetailChange, onSelectPiece, reclamation } = this.props;

        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.AchatInitialFoussier,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: achatInitialFoussierLabel,
            valeurBool: event.target.value === "true"
        }];


        // On va supprimer tous les autres détails
        let detailsToDelete = reclamation.qualificationDetails.map(x => x.code).filter(x => x !== ReclamationQualificationDetailCodes.AchatInitialFoussier);

        let errors = qualificationHelper.getErrors(this.getToCheck('achatInitialFoussier', event.target.value === "true"), this.rules());

        if (event.target.value !== "true")
        {
            onSelectPiece("", errors, false);
        }

        onDetailChange(qualificationDetails, errors, detailsToDelete, true);
    }

    handleQualificationDetailsNePasSelectionnerDePieceChange = (event) => {
        const { onDetailChange, reclamation } = this.props;


        if (event.target.value === "true") {

            const qualificationDetail = {
                position: 1,
                code: ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece,
                type: ReclamationQualificationDetailType.Booleen,
                libelle: 'Ne pas sélectionner de pièce',
                valeurBool: true
            };

            let toCheckValue = this.getToCheck('nePasSelectionnerDePiece', true);

            const errors = qualificationHelper.getErrors(toCheckValue, this.rules());


            // On va supprimer tous les autres détails
            let detailsToDelete = reclamation.qualificationDetails.map(x => x.code).filter(x => x !== ReclamationQualificationDetailCodes.AchatInitialFoussier && x !== ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece);


            onDetailChange(qualificationDetail, errors, detailsToDelete);

            return;
        }



        const qualificationDetail = {
            position: 1,
            code: ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: 'Ne pas sélectionner de pièce',
            valeurBool: false
        };

        let toCheckValue = this.getToCheck('nePasSelectionnerDePiece', false);

        const errors = qualificationHelper.getErrors(toCheckValue, this.rules());


        // On va supprimer tous les détails y compris celui-ci sauf les précédents
        let detailsToDelete = reclamation.qualificationDetails.map(x => x.code).filter(x => x !== ReclamationQualificationDetailCodes.AchatInitialFoussier);


        onDetailChange(qualificationDetail, errors, detailsToDelete);
    }

    handleQualificationDetailsOffrirMajorationHorsGarantieChange = (event) => {
        const { onDetailChange } = this.props;

        // console.log("handleQualificationDetailsOffrirMajorationHorsGarantieChange", event.target.name);
        // console.log("handleQualificationDetailsOffrirMajorationHorsGarantieChange", event.target.value);

        const qualificationDetail = {
            code: ReclamationQualificationDetailCodes.DetailSavOffrirMajorationHorsGarantie,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "Je décide d'offrir la majoration au client",
            valeurBool: event.target.value === 'true'
        };


        onDetailChange(qualificationDetail, null, null);
    }

    handleQualificationDetailsExtensionGarantieChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.ExtensionGarantie,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: extensionGarantieLabel,
            valeurBool: event.target.value === "true"
        }];


        // console.log("handleQualificationDetailsExtensionGarantieChange", event.target.value);
        // console.log("handleQualificationDetailsExtensionGarantieChange", event.target.value === "true");

        const infosExtensionGarantie = this.getInfosExtensionGarantie();

        // console.log("handleQualificationDetailsExtensionGarantieChange", infosExtensionGarantie);


        if (event.target.value === "true") {

            qualificationDetails.push(
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.GarantieProduit,
                    type: ReclamationQualificationDetailType.ChoixSimple,
                    libelle: "Garantie calculé",
                    valeurString: garantiesProduit[0],
                    valeurInteger: 0
                }
            );



            qualificationDetails.push(
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.DelaiGarantie,
                    type: ReclamationQualificationDetailType.Nombre,
                    libelle: "Delai Garantie étendue calculé",
                    valeurInteger: infosExtensionGarantie.delaiExtensionGarantie
                }
            );


        }
        else {

            qualificationDetails.push(
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.GarantieProduit,
                    type: ReclamationQualificationDetailType.ChoixSimple,
                    libelle: "Garantie calculé",
                    valeurString: garantiesProduit[1],
                    valeurInteger: 1
                }
            );


            qualificationDetails.push(
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.DelaiGarantie,
                    type: ReclamationQualificationDetailType.Nombre,
                    libelle: "Delai Garantie non étendue calculé",
                    valeurInteger: infosExtensionGarantie.delaiReference
                }
            );
        }


        onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('extensionGarantie', event.target.value === "true"), this.rules()), null);
    }

    handleQualificationDetailsGarantieProduitChange = (event) => {
        const { onDetailChange } = this.props;


        let detailsToDelete = [];

        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.GarantieProduit,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: garantieProduitLabel,
            valeurString: garantiesProduit[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        }];

        detailsToDelete.push(ReclamationQualificationDetailCodes.SeuilRentabiliteReparationAtteint);

        onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('garantieProduit', parseInt(event.target.value, 10)), this.rules()), detailsToDelete);
    }

    handleQualificationDetailsSeuilRentabiliteReparationAtteintChange = (event, seuil) => {
        const { onDetailChange } = this.props;

        //console.log(event.target.name, event.target.value, seuil);


        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.SeuilRentabiliteReparationAtteint,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: superieurSeuilRentabiliteReparationFormat.replace("{0}", seuil),
            valeurBool: event.target.value === "true",
        }];


        onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('seuilRentabiliteReparationAtteint', event.target.value === "true"), this.rules()), null);
    }

    handleQualificationDetailsPoursuivreChange = (event) => {
        const { onDetailChange } = this.props;

        // console.log(event.target.name, event.target.value);


        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.Poursuivre,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "Souhaitez-vous poursuivre",
            valeurBool: event.target.value === "true",
        }];


        onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('poursuivre', event.target.value === "true"), this.rules()), null);
    }

    handleQualificationDetailsClientInformeChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.ClientInforme,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: clientInformeLabel,
            valeurBool: event.target.checked
        }];

        onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('clientInforme', event.target.checked), this.rules()), null);
    }

    handleQualificationDetailsPriseConnaissanceDemarcheChange = (event) => {
        const { onDetailChange } = this.props;

        let qualificationDetails = [];
        let detailsToDelete = [];

        if (event.target.checked) {
            qualificationDetails.push(
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.DemarcheSAV,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Notification de demande de SAV",
                    valeurString: memoCloture
                });
            qualificationDetails.push(
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.PriseConnaissanceDemarche,
                    type: ReclamationQualificationDetailType.Booleen,
                    libelle: priseConnaissanceDemarcheLabel,
                    valeurBool: event.target.checked
                });
        }
        else {
            detailsToDelete.push(ReclamationQualificationDetailCodes.PriseConnaissanceDemarche);
            detailsToDelete.push(ReclamationQualificationDetailCodes.DemarcheSAV);
        }

        onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('priseConnaissanceDemarche', event.target.checked), this.rules()), detailsToDelete);
    }

    handleQualificationDetailsAttacherBonRetour = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const attacherBonRetourLabel = attacherBonRetourFormat.replace("{0}", reclamation.suiviEmail);

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.AttacherBonRetour,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: attacherBonRetourLabel,
            valeurBool: event.target.checked
        };

        onDetailChange(qualificationDetail, qualificationHelper.getErrors(this.getToCheck('attacherBonRetour', event.target.checked), this.rules()), null);
    }



    handleQualificationDetailsPhotoConsulteeChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.PhotoConsultee,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: photoConsulteeLabel,
            valeurString: photoConsulteeLabels[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        };


        onDetailChange(qualificationDetail, qualificationHelper.getErrors(this.getToCheck('photoConsultee', event.target.value), this.rules()), null);
    }




    handleAddLigne = (ligne) => {
        const { onAddLigne, reclamation, onDetailChange } = this.props;

        let newLignes = [...reclamation.lignes];
        newLignes.push(ligne);

        onAddLigne(ligne, qualificationHelper.getErrors(this.getToCheck('lignes', newLignes), this.rules()));


        var infosGarantie = this.getInfosGarantie(newLignes);

        console.log("handleAddLigne infosGarantie", infosGarantie);

        if (infosGarantie.sousGarantie) {


            const qualificationDetails = [
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.GarantieProduit,
                    type: ReclamationQualificationDetailType.ChoixSimple,
                    libelle: "Garantie calculé",
                    valeurString: garantiesProduit[0],
                    valeurInteger: 0
                },
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.DelaiGarantie,
                    type: ReclamationQualificationDetailType.Nombre,
                    libelle: "Delai Garantie calculé",
                    valeurInteger: infosGarantie.delai
                }
            ];

            onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('garantieProduit', 0), this.rules()), null);

        }
        else {
            const qualificationDetails = [
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.GarantieProduit,
                    type: ReclamationQualificationDetailType.ChoixSimple,
                    libelle: "Garantie calculé",
                    valeurString: garantiesProduit[1],
                    valeurInteger: 1
                },
                {
                    position: 0,
                    code: ReclamationQualificationDetailCodes.DelaiGarantie,
                    type: ReclamationQualificationDetailType.Nombre,
                    libelle: "Delai Garantie calculé",
                    valeurInteger: infosGarantie.delai
                }
            ];

            onDetailChange(qualificationDetails, qualificationHelper.getErrors(this.getToCheck('garantieProduit', 1), this.rules()), null);
        }
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne, reclamation } = this.props;

        onRemoveLigne(numeroLigne, qualificationHelper.getErrors(this.getToCheck('lignes', reclamation.lignes.filter(x => x.numeroLigne !== numeroLigne)), this.rules()));
    }

    handleClickImprimer = () => {
        const { onDetailChange } = this.props;

        window.open('FOUSSIER_conditions_reprise_defaut_produit.pdf');

        const errors = qualificationHelper.getErrors(this.getToCheck('bonRetourImprime', true), this.rules());

        onDetailChange(null, errors, null);

        this.setState(
            {
                ...this.state,
                bonRetourImprime: true
            });
    };

    handleDownloadConditionSAV = (fournisseurId, garantieType, reference, perimetre) => {

        // console.log(fournisseurId, garantieType, reference, perimetre);
        this.setState({ erreurConditionsSAV: false });


        axios.post(`api/fournisseurs/${fournisseurId}/exporter-conditionSAV?garantieType=${garantieType}&reference=${reference}&perimetre=${perimetre}`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurConditionsSAV: true });
            })
            .then(function () {
                // always executed
            });
    };

    handleDownloadConditionSAVById = (detailId) => {

        // console.log("handleDownloadConditionSAVById detailId", detailId);

        this.setState({ erreurConditionsSAV: false });

        const extensionGarantieValue = this.getExtensionGarantie();
        // console.log("handleDownloadConditionSAVById extension", extensionGarantieValue);

        axios.post(`api/conditionSAV-details/${detailId}/exporter/${extensionGarantieValue}`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurConditionsSAV: true });
            })
            .then(function () {
                // always executed
            });
    };


    handleDownloadPreuveAchat = (numeroPiece) => {

        this.setState({ erreurPreuveDAChat: false });

        axios.post(`api/pieces-gestion/${numeroPiece}/export`, {}, { responseType: 'blob' })
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', numeroPiece + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurPreuveDAChat: true });

            })
            .then(function () {
                // always executed
            });
    }

    handleOpenSendMail = (fournisseur) => {
        let result;

        if (fournisseur) {
            result = fournisseur;
        }
        else {
            const { reclamation } = this.props;
            // on récupère le fournisseur dans les qualifications détails
            let fourn = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.Fournisseur);
            if (fourn !== undefined) {
                result = fourn.valeurObject;
            }
            else {
                // on récupère le fournisseur dans les lignes articles
                fourn = reclamation.lignes[0].fournisseur;
                if (fourn !== undefined) {
                    result = fourn;
                }
            }
        }

        if (result) {
            this.setState({
                sendMailServiceAchat: { open: true, fournisseur: result }
            });
        }
    }

    handleCloseSendMail = () => {
        this.setState({
            sendMailServiceAchat: { open: false }
        });
    }

    //#endregion Handlers

    //#region Renders


    renderDepannageDirectClient = () => {
        const { reclamation, utilisateurMagasin } = this.props;

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            return (<DepannageDirectClient name={"depannageDirectClient"} onChange={this.handleChangeOnSubComponent} />);
        } else {
            return null;
        }
    }


    renderEtatProduit = () => {
        const { classes } = this.props;

        const etatProduitValue = this.getEtatProduit().toString();

        return (
            <div className={classes.row}>
                <FormControl required className={classes.formControl}>
                    <FormLabel>{etatProduitLabel}</FormLabel>
                    <RadioGroup id={ReclamationQualificationDetailCodes.EtatProduit} name={ReclamationQualificationDetailCodes.EtatProduit} className={classes.group} value={etatProduitValue} onChange={this.handleQualificationDetailsEtatProduitChange}>
                        {etatsProduit.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}
                    </RadioGroup>
                </FormControl>

                <MessageDialog
                    titre="Attention"
                    contenu="La quantité déclarée dépasse la quantité retournable. Veuillez la corriger."
                    ouvert={this.state.alerteRetournableOpen}
                    init={this.state.alerteRetournableOpen}
                    texteOK="Ok"
                    onOK={() => this.setState({ alerteRetournableOpen: false })}
                />
            </div>
        );
    }


    renderDepannageClient = () => {
        const { classes } = this.props;

        const depannageClientValue = this.getDepannageClient().toString();

        return (
            <div className={classes.row}>
                <FormControl required className={classes.formControl}>
                    <FormLabel>{depannageClientLabel}</FormLabel>
                    <RadioGroup id={ReclamationQualificationDetailCodes.DepannageClient} name={ReclamationQualificationDetailCodes.DepannageClient} className={classes.group} value={depannageClientValue} onChange={this.handleQualificationDetailsDepannageClientChange}>
                        {depannagesClient.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}
                    </RadioGroup>
                </FormControl>
            </div>
        );
    }

    renderDocumentPriseEnCharge = () => {
        const { classes, reclamation } = this.props;

        const clientInformeValue = this.getClientInforme();

        const attacherBonRetourValue = this.getAttacherBonRetour();
        const attacherBonRetourLabel = attacherBonRetourFormat.replace("{0}", reclamation.suiviEmail);

        if(reclamation.type.code === TypeCodes.Cession)
        {
            return null;
        }

        return (

            <div className={classes.row}>

                <FormControl component="fieldset" className={classes.fieldset}>
                    <FormLabel component="legend">Conditions de reprise défaut produit</FormLabel>

                    <FormControlLabel className={classes.row}
                        control={
                            <Checkbox checked={clientInformeValue} onChange={this.handleQualificationDetailsClientInformeChange} value="true" />
                        }
                        label={clientInformeLabel}
                    />



                    <div className={classes.row}>

                        <Button onClick={this.handleClickImprimer} className={this.state.bonRetourImprime ? classes.bonRetourImprime : classes.bonRetourNonImprime}>Imprimer les conditions de reprise défaut produit</Button>

                    </div>


                    {reclamation.suiviEmail && (

                        <FormControlLabel className={classes.row}
                            control={
                                <Checkbox checked={attacherBonRetourValue} onChange={this.handleQualificationDetailsAttacherBonRetour} value="true" />
                            }
                            label={attacherBonRetourLabel}
                        />

                    )}


                </FormControl>

            </div>
        );
    }

    // TODO vérifier utilité ?
    renderMemoCloture = () => {
        const { classes } = this.props;

        const afficheMemoCloture = this.getAfficheMemoCloture();

        const priseConnaissanceDemarcheValue = this.getPriseConnaissanceDemarche();

        let memoClotureLignes = memoCloture.split("\n");

        return (

            <React.Fragment>

                {afficheMemoCloture &&
                    (
                        <FormControl component="fieldset" className={classes.fieldset}>
                            <FormLabel component="legend"></FormLabel>
                            <div className={classes.row}>
                                {memoClotureLignes.map((x, index) => (<p key={index} className={classes.bold}>{x}</p>))}
                            </div>
                            <div className={classes.row}>

                                <FormControlLabel
                                    control={
                                        <Checkbox checked={priseConnaissanceDemarcheValue} onChange={this.handleQualificationDetailsPriseConnaissanceDemarcheChange} value="true" />
                                    }
                                    label={priseConnaissanceDemarcheLabel}
                                />

                            </div>
                        </FormControl>
                    )
                }


            </React.Fragment>
        );
    }

    renderWarningZeroLigne = () => {
        const { classes } = this.props;
        return (<div className={classes.row}>{warningZeroLigne}</div>);
    }

    renderWarningNbLignes = () => {
        const { classes } = this.props;
        return (<div className={classes.row}>{warningNbLignes}</div>);
    }

    renderHeader = () => {
        const { classes, reclamation } = this.props;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>

            </React.Fragment>
        );
    }

    renderAchatInitialFoussier = () => {
        const { classes } = this.props;

        const achatInitialFoussierValue = this.getAchatInitialFoussier();

        return (
            <div className={classes.row}>

                <FormControl component="fieldset" className={classes.formControl} required>
                    <FormLabel component="legend">{achatInitialFoussierLabel}</FormLabel>
                    <RadioGroup
                        name={ReclamationQualificationDetailCodes.AchatInitialFoussier}
                        className={classes.group}
                        value={achatInitialFoussierValue !== null ? (achatInitialFoussierValue ? "true" : "false") : achatInitialFoussierValue}
                        onChange={this.handleQualificationDetailsAchatInitialFoussierChange}
                    >
                        <FormControlLabel data-test-id="achatInitialFoussierOui" className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                        <FormControlLabel data-test-id="achatInitialFoussierNon" className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

            </div>
        );
    }

    renderPoursuivre = (label) => {
        const { classes } = this.props;

        const poursuivreValue = this.getPoursuivre();

        return (
            <div className={classes.row}>

                <FormControl component="fieldset" className={classes.formControl} required>
                    <FormLabel component="legend">{label}</FormLabel>
                    <RadioGroup
                        name={ReclamationQualificationDetailCodes.Poursuivre}
                        className={classes.group}
                        value={poursuivreValue !== null ? (poursuivreValue ? "true" : "false") : poursuivreValue}
                        onChange={this.handleQualificationDetailsPoursuivreChange}
                    >
                        <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

            </div>
        );
    }


    renderContactClient = ({ avecMail }) => {
        const { reclamation } = this.props;

        return (

            <Accordion defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Contact client" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>


                    <TextField style={{ paddingBottom: '8px' }}
                        variant="outlined"
                        fullWidth
                        id="nom-suivi"
                        name="suiviNomContact"
                        label="Nom contact"
                        placeholder="Saisir un contact"
                        onChange={this.handleChange}
                        value={reclamation.suiviNomContact}
                        InputLabelProps={{
                            shrink: true
                        }}
                        required
                    />
                    <TextField style={{ paddingBottom: '8px' }}
                        variant="outlined"
                        fullWidth
                        id="telephone-mobile"
                        name="suiviTelephoneMobile"
                        label="Téléphone mobile"
                        placeholder="Saisir un numéro de téléphone mobile"
                        onChange={this.handleChange}
                        value={reclamation.suiviTelephoneMobile}
                        InputLabelProps={{
                            shrink: true
                        }}
                        required
                    />


                    {avecMail && (

                        <TextField style={{ paddingBottom: '8px' }}
                            variant="outlined"
                            fullWidth
                            id="email-suivi"
                            name="suiviEmail"
                            label="E-mail"
                            placeholder="Saisir une adresse e-mail"
                            onChange={this.handleChange}
                            value={reclamation.suiviEmail}
                            InputLabelProps={{
                                shrink: true
                            }}
                            required
                        />
                    )}

                </AccordionDetails>
            </Accordion>


        );

    }




    renderAcceptationSAV = () => {
        return (
            <AcceptationSAV name={"acceptationSAV"} onChange={this.handleChangeOnSubComponent} />
        );
    }


    renderExtensionGarantie = () => {
        const { classes } = this.props;

        const extensionGarantieValue = this.getExtensionGarantie();

        return (
            <div className={classes.row}>

                <FormControl component="fieldset" className={classes.formControl} required>
                    <FormLabel component="legend">{extensionGarantieLabel}</FormLabel>
                    <RadioGroup
                        name={ReclamationQualificationDetailCodes.ExtensionGarantie}
                        className={classes.group}
                        value={extensionGarantieValue !== null ? (extensionGarantieValue ? "true" : "false") : extensionGarantieValue}
                        onChange={this.handleQualificationDetailsExtensionGarantieChange}
                    >
                        <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

            </div>
        );
    }


    // Accessible sur non achat initial Foussier
    renderConditionsSAVFournisseur = () => {

        const { classes, reclamation } = this.props;
        const { sendMailServiceAchat } = this.state;

        // Obtention du type de garantie depuis détail de réclamation

        let garantie = GarantieType.HorsGarantie;

        const garantieProduit = this.getGarantieProduit();

        if (garantieProduit === 0) {
            garantie = GarantieType.SousGarantieApresUtilisation;
        }

        let codeDepot = reclamation.magasin ? reclamation.magasin.codeDepot : '';

        return (
            <div className={classes.row}>
                <FicheRetourFournisseur
                    name={"ficheRetourFournisseur"}
                    onChange={this.handleChangeOnSubComponent}
                    garantie={garantie}
                    clientId={reclamation.client.id}
                    codeDepot={codeDepot}
                    onOpenSendMail={(fournisseur) => this.handleOpenSendMail(fournisseur)}
                />

                <EnvoiMailServiceAchat
                    open={sendMailServiceAchat.open}
                    fournisseur={sendMailServiceAchat.fournisseur}
                    onClose={() => this.handleCloseSendMail()}
                />

            </div>
        );
    }

    // Achat Foussier
    renderFicheRetourFournisseur = () => {

        var infosGarantie = this.getInfosGarantie();
        const { sendMailServiceAchat } = this.state;

        console.log("renderFicheRetourFournisseur infosGarantie", infosGarantie);

        return (


            <Accordion defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title={'Fiche retour fournisseur ' + (infosGarantie.fournisseurLibelle ? (': ' + infosGarantie.fournisseurLibelle) : '')} />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {infosGarantie.fichierId > 0 && (
                            <Stack direction="column"                            >
                                <p>Veuillez télécharger la fiche de retour fournisseur</p>
                                <Fichier fichierId={infosGarantie.fichierId} />
                            </Stack>
                        )}

                        {infosGarantie.fichierId === 0 && (
                            <>
                                <p>Ce fournisseur n'a pas de fiche retour spécifique</p>
                            </>
                        )}
                        <Stack direction='column'>
                            <p>
                                Si vous indentifiez une anomalie dans ce document conditions fournisseurs,<br/>
                                ou si certaines choses ont changé, n'hésitez pas à nous informer:
                            </p>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => this.handleOpenSendMail()}
                            >
                                Envoyer un mail à info-sav@foussier.fr
                            </Button>
                        </Stack>

                    </Stack>

                    <EnvoiMailServiceAchat
                        open={sendMailServiceAchat.open}
                        fournisseur={sendMailServiceAchat.fournisseur}
                        onClose={() => this.handleCloseSendMail()}
                    />

                </AccordionDetails>
            </Accordion>


        );
    }


    renderLocalisationProduit = () => {

        const { classes, reclamation, agePiece, adresseLivraison } = this.props;

        let garantie = GarantieType.HorsGarantie;
        let adresseRetour = { nom: 'adresse du fournisseur', adresse1: '', adresse2: '', codePostal: '', ville: '' };

        const achatInitialFoussier = this.getAchatInitialFoussier();
        const pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

        if (!achatInitialFoussier || pasDePiece) {
            const garantieProduit = this.getGarantieProduit();

            if (garantieProduit === 0) {
                garantie = GarantieType.SousGarantieApresUtilisation;
            }

            var qualificationDetailFournisseur = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.Fournisseur);

            if (qualificationDetailFournisseur && qualificationDetailFournisseur.valeurObject && qualificationDetailFournisseur.valeurObject.conditionsSAV) {

                var conditionSAV = qualificationDetailFournisseur.valeurObject.conditionsSAV.find(c => c.garantieType === garantie);

                if (conditionSAV && conditionSAV.detail && conditionSAV.detail.adresse) {
                    adresseRetour = conditionSAV.detail.adresse;
                }

            }

        }
        else {

            let conditionSAV = null;

            if (reclamation.lignes[0].fournisseur && reclamation.lignes[0].fournisseur.infosSAV) {

                conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                if (!conditionSAV) {
                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                }
            }

            if (!conditionSAV) {
                conditionSAV = {
                    garantieType: GarantieType.SousGarantieApresUtilisation,
                    delaiReference: 365,
                }
            }
            else {
                adresseRetour = conditionSAV.adresse;
            }


            let sousGarantie = (agePiece <= conditionSAV.delaiReference);

            if (sousGarantie) {
                garantie = GarantieType.SousGarantieApresUtilisation;
            }
            else {

                let sousExtensionGarantie = conditionSAV.delaiExtensionGarantie && (agePiece <= conditionSAV.delaiExtensionGarantie); // TODO test sur le GSG 51

                if (sousExtensionGarantie) {

                    const extensionGarantie = this.getExtensionGarantie();

                    if (extensionGarantie) {
                        garantie = GarantieType.SousGarantieApresUtilisation;
                    }
                }
            }
        }


        return (

            <div className={classes.row}>
                <LocalisationProduit
                    name={"localisationProduit"}
                    onChange={this.handleChangeOnSubComponent}
                    garantie={garantie}
                    adresseLivraison={adresseLivraison}
                    adresseRetour={adresseRetour}
                    reclamation={reclamation}
                />
            </div>
        );
    }


    renderDocumentsUtiles = () => {

        const { classes, reclamation, agePiece } = this.props;
        const { erreurPreuveDAChat, erreurConditionsSAV } = this.state;

        let fournisseurId = 0;
        let garantie = GarantieType.HorsGarantie;
        let reference = "";
        let perimetre = PerimetresSAV.Societe;

        let detailId = 0;

        const achatInitialFoussier = this.getAchatInitialFoussier();

        if (achatInitialFoussier) {

            const pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

            if (pasDePiece) {
                return null; // rien a afficher cans ce cas
            }

            fournisseurId = reclamation.lignes && reclamation.lignes.length && reclamation.lignes[0].fournisseur ? reclamation.lignes[0].fournisseur.id : 0;
            reference = reclamation.lignes && reclamation.lignes.length && reclamation.lignes[0].codeArticle;

            let conditionSAV = null;

            if (reclamation.lignes && reclamation.lignes.length && reclamation.lignes[0].fournisseur && reclamation.lignes[0].fournisseur.infosSAV) {

                conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                if (!conditionSAV) {
                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVSousFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                }

                if (!conditionSAV) {
                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                }

                if (!conditionSAV) {
                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                }
            }

            if (!conditionSAV) {
                conditionSAV = {
                    garantieType: GarantieType.SousGarantieApresUtilisation,
                    delaiReference: 365,
                    detailId: 0
                }
            }
            detailId = conditionSAV.detailId;

            let sousGarantie = (agePiece <= conditionSAV.delaiReference);

            if (sousGarantie) {
                garantie = GarantieType.SousGarantieApresUtilisation;
            }
            else {

                let sousExtensionGarantie = conditionSAV.delaiExtensionGarantie && (agePiece <= conditionSAV.delaiExtensionGarantie); // TODO test sur le GSG 51

                if (sousExtensionGarantie) {

                    const extensionGarantie = this.getExtensionGarantie();

                    if (extensionGarantie) {
                        garantie = GarantieType.SousGarantieApresUtilisation;
                    }
                }
            }
        }
        else {
            fournisseurId = this.getFournisseur().id;

            const garantieProduit = this.getGarantieProduit();

            if (garantieProduit === 0) {
                garantie = GarantieType.SousGarantieApresUtilisation;
            }
        }

        let PdfIcon = (
            <SvgIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" >
                <path d="M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z" />
            </SvgIcon>
        );

        return (
            <div className={classes.row}>

                <Accordion defaultExpanded={true} elevation={3}>

                    <QualificationAccordionSummary title="Documents utiles" />

                    <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                        {!fournisseurId && (
                            <p>Pas de fournisseur sur cet article, merci de le signaler au service Achat</p>
                        )}

                        <div style={{ display: 'flex', flexDirection: 'row' }}>

                            {(fournisseurId !== 0 && detailId > 0) && (
                                <Button className={classes.marginRight} variant="contained" color="primary" onClick={e => this.handleDownloadConditionSAVById(detailId)}>{PdfIcon} Conditions SAV fournisseur</Button>
                            )}

                            {(fournisseurId !== 0 && detailId === 0) && (
                                <Button className={classes.marginRight} variant="contained" color="primary" onClick={e => this.handleDownloadConditionSAV(fournisseurId, garantie, reference, perimetre)}>{PdfIcon} Conditions SAV fournisseur</Button>
                            )}

                            {reclamation.numeroPiece && (
                                <Button className={classes.marginRight} variant="contained" color="primary" onClick={e => this.handleDownloadPreuveAchat(reclamation.pieceCle || reclamation.numeroPiece)}>{PdfIcon} Preuve d'achat</Button>
                            )}

                        </div>

                        {erreurConditionsSAV && (
                            <>
                                <p>Les conditions SAV de ce fournisseur ne sont pas spécifiées</p>
                            </>
                        )}

                        {erreurPreuveDAChat && (
                            <p>La preuve d'achat est indisponible, vous pouvez la rééditer depuis FMCP.</p>
                        )}

                    </AccordionDetails>
                </Accordion>


            </div>


        );
    }


    renderPriseEnCharge = () => {
        const { classes, reclamation, dateAchat, adresseLivraison } = this.props;

        let designation = '';
        let codeArticle = '';
        let fournisseurCode = '';
        let numeroPiece = '';


        const achatInitialFoussier = this.getAchatInitialFoussier();
        const localisationProduit = this.getLocalisationProduit();
        const pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

        let adresseRenvoi = adresseLivraison;
        let renvoiRequis = true;

        if (localisationProduit === '2') { // Chez le client

            const situationArticle = this.getSituationArticle();

            if (situationArticle === '1') { // Non déplaçable

                renvoiRequis = false;
            }
        }


        if (achatInitialFoussier && !pasDePiece) {

            designation = reclamation.lignes[0].designationArticle;
            codeArticle = reclamation.lignes[0].codeArticle;
            fournisseurCode = reclamation.lignes[0].fournisseur ? reclamation.lignes[0].fournisseur.code : '';
            numeroPiece = reclamation.numeroPiece;

        }
        else {
            let fournisseur = this.getFournisseur();

            fournisseurCode = fournisseur.code;
        }


        let codeDepot = reclamation.magasin ? reclamation.magasin.codeDepot : '';

        // Obtention du type de garantie depuis détail de réclamation

        let garantie = GarantieType.HorsGarantie;

        const garantieProduit = this.getGarantieProduit();

        if (garantieProduit === 0) {
            garantie = GarantieType.SousGarantieApresUtilisation;
        }

        return (
            <div className={classes.row}>
                <PriseEnCharge
                    name={"priseEnCharge"}
                    onChange={this.handleChangeOnSubComponent}

                    designation={designation}
                    codeArticle={codeArticle}
                    fournisseurCode={fournisseurCode}
                    dateAchat={dateAchat}
                    numeroPiece={numeroPiece}

                    adresseRenvoi={adresseRenvoi}
                    renvoiRequis={renvoiRequis}
                    reclamation={reclamation}

                    garantie={garantie}
                />
            </div>
        );
    }

    renderSavByFoussierConcerne = () => {
        const { classes } = this.props;
        return (
            <div className={classes.row}>
                <SavByFoussierConcerne
                    name={"savByFoussierConcerne"}
                    onChange={this.handleChangeOnSubComponent}
                />
            </div>
        );
    }


    renderSavByFoussierProduit = () => {
        const { classes, reclamation, dateAchat } = this.props;

        let designation = '';

        let delaiReference = 366;
        let dateFinGarantie = null;

        let nonFoussierHorsGarantie = false;

        const achatInitialFoussier = this.getAchatInitialFoussier();

        let fournisseurId = 0;

        if (achatInitialFoussier) {

            const pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

            if (pasDePiece) {

                let fournisseur = this.getFournisseur();
                fournisseurId = fournisseur.id;

                let garantie = GarantieType.HorsGarantie;

                nonFoussierHorsGarantie = true; // TODO revoir nommage car ici on est en foussier Sans pièce

                let conditionSAV = fournisseur.conditionsSAV.find(c => c.garantieType === garantie);

                if (conditionSAV.detail) {
                    delaiReference = conditionSAV.detail.delaiReference;
                }

            }
            else {

                designation = reclamation.lignes[0].designationArticle;


                let conditionSAV = null;
                if (reclamation.lignes[0].fournisseur && reclamation.lignes[0].fournisseur.infosSAV) {

                    fournisseurId = reclamation.lignes[0].fournisseur.id;

                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVSousFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                    }

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                    }

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                    }
                }
                if (!conditionSAV) {
                    conditionSAV = {
                        garantieType: GarantieType.SousGarantieApresUtilisation,
                        delaiReference: 365,
                        detailId: 0
                    }
                }

                delaiReference = conditionSAV.delaiReference;

                dateFinGarantie = dateHelper.addDays(dateAchat, delaiReference);
            }


        }
        else {

            let fournisseur = this.getFournisseur();
            fournisseurId = fournisseur.id;

            let garantie = GarantieType.HorsGarantie;

            const garantieProduit = this.getGarantieProduit();

            if (garantieProduit === 0) {
                garantie = GarantieType.SousGarantieApresUtilisation;
            }
            else {
                nonFoussierHorsGarantie = true;
            }

            let conditionSAV = fournisseur.conditionsSAV.find(c => c.garantieType === garantie);

            if (conditionSAV.detail) {
                delaiReference = conditionSAV.detail.delaiReference;
            }
        }

        //console.log("renderSavByFoussierProduit fournisseurId", fournisseurId);


        return (
            <div className={classes.row}>
                <SavByFoussierProduit
                    name={"savByFoussierProduit"}
                    onChange={this.handleChangeOnSubComponent}

                    designation={designation}
                    dateAchat={dateAchat}
                    dateFinGarantie={dateFinGarantie}

                    blOuFacture={reclamation.numeroPiece}
                    delaiReference={delaiReference}

                    nonFoussierHorsGarantie={nonFoussierHorsGarantie}

                    fournisseurId={fournisseurId}
                />
            </div>
        );
    }


    renderSavByFoussierExtensionGarantie = () => {
        const { classes, reclamation } = this.props;

        let delaiExtensionGarantie = null;
        let dateFinExtensionGarantie = null;

        const achatInitialFoussier = this.getAchatInitialFoussier();

        let dateAchat = this.getDetail(ReclamationQualificationDetailCodes.DetailSavDateAchat, 'valeurDate');


        if (achatInitialFoussier) {

            const pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

            if (pasDePiece) {
                return null;
            }
            else {

                let conditionSAV = null;
                if (reclamation.lignes[0].fournisseur && reclamation.lignes[0].fournisseur.infosSAV) {

                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVSousFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                    }

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVFamille.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                    }

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === GarantieType.SousGarantieApresUtilisation && x.perimetre === PerimetresSAV.Societe);
                    }
                }
                if (!conditionSAV) {
                    conditionSAV = {
                        garantieType: GarantieType.SousGarantieApresUtilisation,
                        delaiReference: 365,
                        delaiExtensionGarantie: null,
                        detailId: 0
                    }
                }

                delaiExtensionGarantie = conditionSAV.delaiExtensionGarantie;

                if (delaiExtensionGarantie) {
                    dateFinExtensionGarantie = dateHelper.addDays(dateAchat, delaiExtensionGarantie).getTime();
                }
            }


        }
        else {

            let garantieProduit = this.getGarantieProduit();

            if (garantieProduit === 1) {
                return null;
            }


            let fournisseur = this.getFournisseur();


            let garantie = GarantieType.HorsGarantie;


            if (garantieProduit === 0) {
                garantie = GarantieType.SousGarantieApresUtilisation;
            }

            let conditionSAV = fournisseur.conditionsSAV.find(c => c.garantieType === garantie);

            if (conditionSAV.detail) {
                delaiExtensionGarantie = conditionSAV.detail.delaiExtensionGarantie;

                if (delaiExtensionGarantie) {
                    dateFinExtensionGarantie = dateHelper.addDays(dateAchat, delaiExtensionGarantie).getTime();
                }
            }
        }

        // console.log("avant SavByFoussierExtensionGarantie dateFinExtensionGarantie", dateFinExtensionGarantie);

        return (
            <div className={classes.row}>
                <SavByFoussierExtensionGarantie
                    name={"savByFoussierExtensionGarantie"}
                    onChange={this.handleChangeOnSubComponent}

                    dateFinExtensionGarantie={dateFinExtensionGarantie}

                />
            </div>
        );
    }


    renderSavByFoussierGarantieCalculee = () => {
        const { classes } = this.props;

        var garantie = GarantieType.SousGarantieApresUtilisation;

        var dateFinGarantie = this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie, 'valeurDate');

        if (dateFinGarantie === null) { // Au cas ou elle n'est pas obligatoire dans le composant SavByFoussierProduit
            garantie = GarantieType.HorsGarantie;
        }
        else {

            var garantieEtendue = this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue, 'valeurBool');

            if (garantieEtendue) {
                var dateFinExtensionGarantie = this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie, 'valeurDate');
                if (dateFinExtensionGarantie) {
                    dateFinGarantie = dateFinExtensionGarantie;
                }
            }

            if (new Date() > dateFinGarantie) {
                garantie = GarantieType.HorsGarantie;
            }
        }


        return (
            <div className={classes.row}>
                <SavByFoussierGarantieCalculee
                    name={"savByFoussierGarantieCalculee"}
                    onChange={this.handleChangeOnSubComponent}
                    dateFinGarantie={dateFinGarantie ? dateFinGarantie.getTime() : null}
                    garantie={garantie}
                />
            </div>
        );
    }


    renderSavByFoussierCommentaireFicheFournisseur = () => {
        const { reclamation } = this.props;

        var garantie = GarantieType.SousGarantieApresUtilisation;

        var dateFinGarantie = this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie, 'valeurDate');

        var garantieEtendue = this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue, 'valeurBool');

        if (garantieEtendue) {
            var dateFinExtensionGarantie = this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie, 'valeurDate');
            if (dateFinExtensionGarantie) {
                dateFinGarantie = dateFinExtensionGarantie;
            }
        }

        if (new Date() > dateFinGarantie) {
            garantie = GarantieType.HorsGarantie;
        }

        // Cas achat initial foussier, commentaire au niveau article, famille ..

        // Cas non initial foussier, commentaire sur la condition du fournisseur

        let commentaire = "";

        const achatInitialFoussier = this.getAchatInitialFoussier();

        if (!achatInitialFoussier) {

            let qualificationDetailFournisseur = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.Fournisseur);

            if (qualificationDetailFournisseur && qualificationDetailFournisseur.valeurObject && qualificationDetailFournisseur.valeurObject.conditionsSAV) {

                let conditionSAV = qualificationDetailFournisseur.valeurObject.conditionsSAV.find(c => c.garantieType === garantie);


                if (conditionSAV) {

                    commentaire = conditionSAV.detail.commentaire;
                }

            }

        }
        else {


            const pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

            if (pasDePiece) {
                let qualificationDetailFournisseur = reclamation.qualificationDetails.find(x => x.code === ReclamationQualificationDetailCodes.Fournisseur);

                if (qualificationDetailFournisseur && qualificationDetailFournisseur.valeurObject && qualificationDetailFournisseur.valeurObject.conditionsSAV) {

                    let conditionSAV = qualificationDetailFournisseur.valeurObject.conditionsSAV.find(c => c.garantieType === GarantieType.HorsGarantie);


                    if (conditionSAV) {

                        commentaire = conditionSAV.detail.commentaire;
                    }

                }
            }
            else {

                let conditionSAV = null;

                if (reclamation.lignes[0].fournisseur && reclamation.lignes[0].fournisseur.infosSAV) {

                    conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAVArticle.find(x => x.garantieType === garantie && x.perimetre === PerimetresSAV.Societe);

                    if (!conditionSAV) {
                        conditionSAV = reclamation.lignes[0].fournisseur.infosSAV.conditionsSAV.find(x => x.garantieType === garantie && x.perimetre === PerimetresSAV.Societe);
                    }
                }
                if (conditionSAV) {

                    commentaire = conditionSAV.commentaire;
                }
            }



        }



        return (
            <MessageDialog titre="Commentaire de la fiche fournisseur" contenu={commentaire} ouvert={!!commentaire} init={garantieEtendue} />
        );
    }

    renderSavByFoussierPriseEnCharge = () => {
        const { classes } = this.props;

        return (
            <div className={classes.row}>
                <SavByFoussierPriseEnCharge
                    name={"savByFoussierPriseEnCharge"}
                    onChange={this.handleChangeOnSubComponent}
                />
            </div>
        );
    }


    renderSavByFoussierPreuveAchat = () => {

        const { classes } = this.props;

        return (
            <div className={classes.row}>

                <SavByFoussierPreuveAchat
                    name={"savByFoussierPreuveAchat"}
                    onChange={this.handleChangeOnSubComponent}
                />
                
            </div>
        );

    }


    renderSavByFoussierRestitution = () => {
        const { classes } = this.props;

        return (
            <div className={classes.row}>
                <SavByFoussierRestitution
                    name={"savByFoussierRestitution"}
                    onChange={this.handleChangeOnSubComponent}
                />
            </div>
        );
    }


    renderSavByFoussierBonTransport = () => {
        const { classes, enlevementMagasin, adresseLivraison, reclamation } = this.props;


        let codeDepot = reclamation.magasin ? reclamation.magasin.codeDepot : '';

        return (
            <div className={classes.row}>
                <SavByFoussierBonTransport
                    name={"savByFoussierBonTransport"}
                    onChange={this.handleChangeOnSubComponent}
                    adresseLivraison={enlevementMagasin ? null : adresseLivraison}
                    codeDepot={codeDepot}
                />
            </div>
        );
    }

    renderSavByFoussierRenvoi = () => {
        const { classes, enlevementMagasin, adresseLivraison, reclamation } = this.props;
                
        return (
            <div className={classes.row}>
                <SavByFoussierRenvoi
                    name={"savByFoussierRenvoi"}
                    onChange={this.handleChangeOnSubComponent}
                    adresseRenvoi={enlevementMagasin ? null : adresseLivraison}
                    reclamation={reclamation}
                />
            </div>
        );
    }


    renderPieceGestionSearch = () => {
        const { reclamation, namespace } = this.props;

        const { expandedPanel } = this.state;


        let codeDepot = reclamation.magasin ? reclamation.magasin.codeDepot : '';

        let pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');


        return (
            <>
                {!pasDePiece && (

                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')} elevation={3}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}>
                            <Typography >Rechercher une pièce</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos
                                logistiqueInfos={false}
                                savInfos
                                codeDepot={codeDepot}
                                defautNumeroPiece={reclamation.numeroPiece}
                            />
                        </AccordionDetails>
                    </Accordion>

                )}


                {!reclamation.numeroPiece && (

                    <FormControlLabel
                        control={
                            <Switch
                                name={ReclamationQualificationDetailCodes.NePasSelectionnerDePiece}
                                checked={pasDePiece}
                                onChange={this.handleQualificationDetailsNePasSelectionnerDePieceChange}
                                value={!pasDePiece}
                                color="secondary"
                            />
                        }
                        label="Ne pas sélectionner de pièce"
                        labelPlacement="start"
                    />

                )}


            </>
        );
    }


    renderLigneGestionQualification = () => {
        const { classes, reclamation } = this.props;

        const { expandedPanel } = this.state;

        return (
            <div className={classes.row}>

                <Accordion sx={{ mt: 2 }} expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}>
                        <Typography >Sélectionner la ligne de commande qui pose problème</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.flexContainer}>
                        <div className={classes.row}>
                            <LigneGestionQualification
                                reclamation={reclamation}
                                onAddLigne={this.handleAddLigne}
                                onRemoveLigne={this.handleRemoveLigne}
                                typeAnomalie={AnomalieType.DefautProduitPremiereUtilisation}
                                afficherQuantiteRetournable
                                capperSaisie={false}
                            />
                        </div>

                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }


    renderGarantieProduit = () => {
        const { classes } = this.props;

        const garantieProduitValue = this.getGarantieProduit().toString();

        return (
            <div className={classes.row}>
                <FormControl required className={classes.formControl}>
                    <FormLabel>{garantieProduitLabel}</FormLabel>
                    <RadioGroup id={ReclamationQualificationDetailCodes.GarantieProduit} name={ReclamationQualificationDetailCodes.GarantieProduit} className={classes.group} value={garantieProduitValue} onChange={this.handleQualificationDetailsGarantieProduitChange}>
                        {garantiesProduit.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}
                    </RadioGroup>
                </FormControl>
            </div>
        );
    }


    renderSeuilRentabiliteReparationAtteint = (seuil) => {
        const { classes } = this.props;

        const seuilRentabiliteReparationAtteintValue = this.getSeuilRentabiliteReparationAtteint();

        return (
            <div className={classes.row}>

                <FormControl component="fieldset" className={classes.formControl} required>
                    <FormLabel component="legend">{superieurSeuilRentabiliteReparationFormat.replace("{0}", seuil)}</FormLabel>
                    <RadioGroup
                        name={ReclamationQualificationDetailCodes.SeuilRentabiliteReparationAtteint}
                        className={classes.group}
                        value={seuilRentabiliteReparationAtteintValue !== null ? (seuilRentabiliteReparationAtteintValue ? "true" : "false") : seuilRentabiliteReparationAtteintValue}
                        onChange={e => this.handleQualificationDetailsSeuilRentabiliteReparationAtteintChange(e, seuil)}
                    >
                        <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

            </div>
        );
    }


    renderMajorationHorsGarantie = () => {
        const { closeAddReclamationDialog } = this.props;

        let offrirMajorationHorsGarantie = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavOffrirMajorationHorsGarantie, 'valeurBool');

        return (
            <>
                <SavHorsGarantieMajorationDialog onNOK={closeAddReclamationDialog} />

                <FormControlLabel
                    control={
                        <Switch
                            name={ReclamationQualificationDetailCodes.DetailSavOffrirMajorationHorsGarantie}
                            checked={offrirMajorationHorsGarantie}
                            onChange={this.handleQualificationDetailsOffrirMajorationHorsGarantieChange}
                            value={!offrirMajorationHorsGarantie}
                            color="secondary"
                        />
                    }
                    label="Je décide d'offrir la majoration au client"
                    labelPlacement="start"
                />

            </>

        );
    }


    renderPropositionAchat = () => {

        return (
            <PropositionAchat name={"propositionAchat"} onChange={this.handleChangeOnSubComponent} />
        );
    }


    renderSavByFoussierAvertissementHorsGarantie = () => {

        let achatInitialFoussier = this.getAchatInitialFoussier();
        let pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

        if (!achatInitialFoussier) {

            let garantieProduit = this.getGarantieProduit();
            if (garantieProduit === 0) {
                return null;
            }
        }
        else {

            if (!pasDePiece) {
                return null;
            }
        }

        let contenu = "Les forfaits sont valables uniquement pour les machines ayant moins de 5 ans d'ancienneté.\nAu-delà, vous pouvez l'envoyer chez le fabricant pour un devis de réparation.\nLe délai de traitement en sera rallongé.";

        return (
            <MessageDialog titre="Avertissement" contenu={contenu} ouvert={true} init={true} />
        );
    }




    renderPriseConnaissancePhoto = () => {
        const { classes, reclamation, colisLogistiques } = this.props;

        const photoConsulteeValue = this.getDetail(ReclamationQualificationDetailCodes.PhotoConsultee, 'valeurInteger');

        let reclaCodes = reclamation.lignes.map(x => x.codeArticle);


        let colisLogistiquesPhoto = colisLogistiques.map(x => {

            let codesArticles = x.lignes.map(x => x.codeArticle);
            let c = {
                photoId: x.photoId,
                numeroSupport: x.numeroSupport,
                concerneRecla: reclaCodes.some(r => codesArticles.indexOf(r) >= 0)
            };
            return c;
        });



        let afficherQuestion = colisLogistiquesPhoto.some(x => x.concerneRecla && x.photoId);

        return (

            <>

                {afficherQuestion && (
                    <>

                        <div className={classes.row}>

                            <FormControl required className={classes.formControl}>
                                <FormLabel component="legend" sx={{ display: 'flex' }}>
                                    {photoConsulteeLabel}

                                    {colisLogistiquesPhoto.map((colis, index) => {
                                        return (
                                            <ColisLogistiquePhoto
                                                key={index}
                                                colis={colis}
                                                disabledMessage={!colis.photoId ? "pas de photo de ce colis" : !colis.concerneRecla ? "colis non concerné" : ""}
                                                mode={"button"}
                                                size={"large"}
                                            />
                                        );
                                    })}

                                </FormLabel>
                                <RadioGroup
                                    id={ReclamationQualificationDetailCodes.PhotoConsultee}
                                    name={ReclamationQualificationDetailCodes.PhotoConsultee}
                                    className={classes.group}
                                    value={photoConsulteeValue}
                                    onChange={this.handleQualificationDetailsPhotoConsulteeChange}>
                                    {photoConsulteeLabels.map((reponse, index) => (
                                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                    ))}
                                </RadioGroup>
                            </FormControl>

                        </div>

                    </>
                )}
            </>


        );

    }

    //#endregion Renders


    finalisationSAVDescriptor =
        {
            name: 'Finalisation du SAV achat initial ou non',
            renderer: this.renderLocalisationProduit,
            getter: () => this.state.mountedSubComponents.find(x => x === "localisationProduit") !== undefined && this.state.mountedSubComponentsError.find(x => x === "localisationProduit") === undefined,
            subComponents: [
                {
                    name: 'localisation produit saisie et sans erreur',
                    tester: a => a,
                    descriptor: [
                        {
                            name: 'Documents utiles',
                            renderer: this.renderDocumentsUtiles
                        },
                        {
                            name: "Informations complémentaires pour l'édition du document de prise en charge SAV et du document fournisseur",
                            renderer: this.renderPriseEnCharge,
                            getter: () => this.state.mountedSubComponents.find(x => x === "priseEnCharge") !== undefined && this.state.mountedSubComponentsError.find(x => x === "priseEnCharge") === undefined,
                            subComponents: [{
                                name: 'prise en charge saisie et sans erreur',
                                tester: a => a,
                                descriptor: [
                                    {
                                        name: 'Contact client',
                                        renderer: this.renderContactClient,
                                    },
                                    {
                                        name: 'Demande d\'acceptation du SAV',
                                        renderer: this.renderAcceptationSAV,
                                        getter: this.getAcceptationSAV,
                                        subComponents: [
                                            {
                                                name: 'SAV refuse',
                                                tester: a => a === false,
                                                descriptor: [
                                                    {
                                                        name: 'Proposition achat neuf',
                                                        renderer: this.renderPropositionAchat
                                                    }
                                                ]
                                            }
                                        ]
                                    }]
                            }]
                        }
                    ]
                }
            ]
        };


    procedureSAVFoussierDescriptor = [
        {
            name: 'procedureSAVFoussierDescriptor',
            getter: this.getInfosGarantie,
            subComponents: [
                {
                    name: 'procedureSAVFoussierDescriptor sub1',
                    tester: a => {
                        console.log("parIci", a);
                        return a.sousGarantie && (a.delai > 9998 || a.montant >= seuilRentabiliteReparationSousGarantie);
                    },
                    descriptor: [
                        {
                            name: "fiche retour fournisseur",
                            renderer: this.renderFicheRetourFournisseur
                        },
                        this.finalisationSAVDescriptor,
                    ]
                },
                {
                    name: 'procedureSAVFoussierDescriptor sub2',
                    tester: a => a.sousGarantie && (a.delai < 9999 && a.montant < seuilRentabiliteReparationSousGarantie),
                    descriptor: [
                        {
                            name: "Article non rentable (1)",
                            renderer: (a) => (<p>Article non rentable à la remise en réparation, il ne peut faire l'objet d'aucun S.A.V. (1) {a.delai}</p>)
                        },
                        {
                            name: "dépanner le client",
                            renderer: this.renderDepannageClient,
                            getter: this.getDepannageClient,
                            subComponents: []
                        }
                    ]
                },
                {
                    name: 'procedureSAVFoussierDescriptor sub3',
                    tester: a => !a.sousGarantie && a.sousExtensionGarantie,
                    descriptor: [
                        {
                            name: 'Question extension de garantie',
                            renderer: this.renderExtensionGarantie,
                            getter: this.getInfosExtensionGarantie,
                            subComponents: [
                                {
                                    name: 'extension garantie OUI + montant < seuil sous garantie',
                                    tester: a => a.extensionGarantie === true && a.montant < seuilRentabiliteReparationSousGarantie,
                                    descriptor: [
                                        {
                                            name: "Article non rentable (2)",
                                            renderer: () => (<p>Article non rentable à la remise en réparation, il ne peut faire l'objet d'aucun S.A.V.  (2)</p>)
                                        },
                                        {
                                            name: "dépanner le client",
                                            renderer: this.renderDepannageClient,
                                            getter: this.getDepannageClient,
                                            subComponents: []
                                        }
                                    ]
                                },
                                {
                                    name: 'extension garantie OUI + montant >= seuil sous garantie',
                                    tester: a => a.extensionGarantie === true && a.montant >= seuilRentabiliteReparationSousGarantie,
                                    descriptor: [
                                        { renderer: () => <p>Le certificat d'extension de garantie doit être ajouté en pièce jointe.</p> },
                                        { renderer: this.renderFicheRetourFournisseur },
                                        this.finalisationSAVDescriptor
                                    ]
                                },
                                {
                                    name: 'extension garantie NON + montant < seuil hors garantie',
                                    tester: a => a.extensionGarantie === false && a.montant < seuilRentabiliteReparationHorsGarantie,
                                    descriptor: [{
                                        name: "poursuite SAV hors garantie",
                                        renderer: () => this.renderPoursuivre(poursuivreHorsGarantieAchatFoussierLabel),
                                        getter: this.getPoursuivre,
                                        subComponents: [
                                            {
                                                name: 'poursuivre OUI',
                                                tester: a => a === true,
                                                descriptor: [
                                                    { renderer: this.renderFicheRetourFournisseur },
                                                    this.finalisationSAVDescriptor
                                                ]
                                            },
                                            {
                                                name: 'poursuivre NON',
                                                tester: a => a === false,
                                                descriptor: [
                                                    {
                                                        name: 'Proposition achat neuf',
                                                        renderer: this.renderPropositionAchat
                                                    }
                                                ]
                                            },
                                        ]
                                    }]
                                },
                                {
                                    name: 'extension garantie NON + montant >= seuil hors garantie',
                                    tester: a => a.extensionGarantie === false && a.montant >= seuilRentabiliteReparationHorsGarantie,
                                    descriptor: [
                                        { renderer: this.renderFicheRetourFournisseur },
                                        this.finalisationSAVDescriptor,
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name: 'hors garantie et hors extension + montant >= seuil hors garantie',
                    tester: a => !a.sousGarantie && !a.sousExtensionGarantie && a.montant >= seuilRentabiliteReparationHorsGarantie,
                    descriptor: [
                        { renderer: this.renderFicheRetourFournisseur },
                        this.finalisationSAVDescriptor
                    ]
                },
                {
                    name: 'procedureSAVFoussierDescriptor sub4',
                    tester: a => !a.sousGarantie && !a.sousExtensionGarantie && a.montant < seuilRentabiliteReparationHorsGarantie,
                    descriptor: [{
                        name: "poursuite SAV hors garantie",
                        renderer: () => this.renderPoursuivre(poursuivreHorsGarantieAchatFoussierLabel),
                        getter: this.getPoursuivre,
                        subComponents: [
                            {
                                name: 'poursuivre OUI',
                                tester: a => a === true,
                                descriptor: [
                                    { renderer: this.renderFicheRetourFournisseur },
                                    this.finalisationSAVDescriptor
                                ]
                            },
                            {
                                name: 'poursuivre NON',
                                tester: a => a === false,
                                descriptor: [
                                    {
                                        name: 'Proposition achat neuf',
                                        renderer: this.renderPropositionAchat
                                    }
                                ]
                            },
                        ]
                    }]
                }
            ]
        }
    ];


    procedureSAVByFoussierDescriptor = [
        {
            name: 'procedureSAVByFoussierDescriptor',
            renderer: () => <p>Début de formulaire SAV by Foussier</p>
        },
        {
            name: 'SavByFoussierAvertissementHorsGarantie',
            renderer: this.renderSavByFoussierAvertissementHorsGarantie,
        },
        {
            name: 'SavByFoussierConcerne',
            renderer: this.renderSavByFoussierConcerne,
            getter: () => this.state.mountedSubComponents.find(x => x === "savByFoussierConcerne") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierConcerne") === undefined,
            subComponents: [
                {
                    name: 'SAV by Foussier concerne saisi et sans erreur',
                    tester: a => a,
                    descriptor: [
                        {
                            name: "SavByFoussier zone Produit",
                            renderer: this.renderSavByFoussierProduit,
                            getter: () => this.state.mountedSubComponents.find(x => x === "savByFoussierProduit") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierProduit") === undefined,
                            subComponents: [
                                {
                                    name: 'SAV by Foussier produit saisi et sans erreur',
                                    tester: a => a,
                                    descriptor: [
                                        {
                                            renderer: this.renderSavByFoussierExtensionGarantie,
                                            getter: () => {
                                                return {
                                                    demandeExtensionGarantie: this.state.mountedSubComponents.find(x => x === "savByFoussierExtensionGarantie") !== undefined,
                                                    reponseExtensionGarantie: this.state.mountedSubComponents.find(x => x === "savByFoussierExtensionGarantie") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierExtensionGarantie") === undefined,
                                                };
                                            },
                                            subComponents: [
                                                {
                                                    name: 'extension garantie repondue ou non demandee',
                                                    tester: a => a.demandeExtensionGarantie && a.reponseExtensionGarantie || !a.demandeExtensionGarantie,
                                                    descriptor: [
                                                        {
                                                            renderer: this.renderSavByFoussierGarantieCalculee,
                                                        },
                                                        {
                                                            renderer: this.renderSavByFoussierCommentaireFicheFournisseur,
                                                        },
                                                        {
                                                            renderer: this.renderSavByFoussierPriseEnCharge,
                                                            getter: () => {
                                                                return {
                                                                    priseEnChargeOK: this.state.mountedSubComponents.find(x => x === "savByFoussierPriseEnCharge") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierPriseEnCharge") === undefined,
                                                                    priseEnChargeSousGarantie: this.getDetail(ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge, 'valeurInteger') === "0",
                                                                    preuveAchatObligatoire: this.props.reclamation.lignes && this.props.reclamation.lignes.length && this.props.reclamation.lignes[0].fournisseur.infosSAV.preuveAchatObligatoire,
                                                                };
                                                            },
                                                            subComponents: [
                                                                {
                                                                    name: 'prise en charge OK + sous garantie + preuve achat obligatoire',
                                                                    tester: a => a.priseEnChargeOK && a.priseEnChargeSousGarantie && a.preuveAchatObligatoire,
                                                                    descriptor: [
                                                                        {
                                                                            renderer: this.renderSavByFoussierPreuveAchat 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    name: 'prise en charge OK',
                                                                    tester: a => a.priseEnChargeOK,
                                                                    descriptor: [
                                                                        {
                                                                            renderer: this.renderSavByFoussierRestitution,
                                                                            getter: () => this.state.mountedSubComponents.find(x => x === "savByFoussierRestitution") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierRestitution") === undefined,
                                                                            subComponents: [
                                                                                {
                                                                                    name: 'restitution saisie et sans erreur',
                                                                                    tester: a => a,
                                                                                    descriptor: [
                                                                                        {
                                                                                            renderer: this.renderSavByFoussierBonTransport,
                                                                                            getter: () => this.state.mountedSubComponents.find(x => x === "savByFoussierBonTransport") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierBonTransport") === undefined,
                                                                                            subComponents: [
                                                                                                {
                                                                                                    name: 'bon de transport saisi et sans erreur',
                                                                                                    tester: a => a,
                                                                                                    descriptor: [
                                                                                                        {
                                                                                                            renderer: this.renderSavByFoussierRenvoi,
                                                                                                            getter: () => this.state.mountedSubComponents.find(x => x === "savByFoussierRenvoi") !== undefined && this.state.mountedSubComponentsError.find(x => x === "savByFoussierRenvoi") === undefined,
                                                                                                            subComponents: [
                                                                                                                {
                                                                                                                    name: 'renvoi saisi et sans erreur',
                                                                                                                    tester: a => a,
                                                                                                                    descriptor: [
                                                                                                                        {
                                                                                                                            name: 'Contact client',
                                                                                                                            renderer: () => this.renderContactClient({ avecMail: true }),
                                                                                                                        },
                                                                                                                        {
                                                                                                                            name: 'Confirmation émetteur',
                                                                                                                            renderer: this.renderConfirmationEmetteur,
                                                                                                                        },
                                                                                                                        {
                                                                                                                            name: 'Demande d\'acceptation du SAV',
                                                                                                                            renderer: this.renderAcceptationSAV,
                                                                                                                            getter: this.getAcceptationSAV,
                                                                                                                            subComponents: [
                                                                                                                                {
                                                                                                                                    name: 'SAV refuse',
                                                                                                                                    tester: a => a === false,
                                                                                                                                    descriptor: [
                                                                                                                                        {
                                                                                                                                            renderer: () => (<p>Le client ne souhaite pas poursuivre la démarche</p>)
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
            ]
        }
    ];


    achatInitialFoussierDescriptor = [
        {
            name: 'achatInitialFoussierDescriptor',
            renderer: this.renderPieceGestionSearch,
            getter: () => {
                let pasDePiece = !!this.getDetail(ReclamationQualificationDetailCodes.DetailSavNePasSelectionnerDePiece, 'valeurBool');

                return {
                    pasDePiece,
                    numeroPiece: this.props.reclamation.numeroPiece,
                    pieceGestionLignesLoaded: this.props.pieceGestionLignesLoaded,
                };
            },
            subComponents: [
                {
                    name: 'achat foussier sans pièce',
                    tester: a => a.pasDePiece,

                    descriptor: [
                        {
                            renderer: () => this.renderSeuilRentabiliteReparationAtteint(seuilRentabiliteReparationHorsGarantie),
                            getter: this.getSeuilRentabiliteReparationAtteint,
                            subComponents: [
                                {
                                    name: 'SeuilRentabiliteReparationAtteint : NON',
                                    tester: a => a === false,
                                    descriptor: [
                                        {
                                            name: "poursuite SAV hors garantie achat initial foussier sans pièce",
                                            renderer: () => this.renderPoursuivre(poursuivreHorsGarantieNonAchatFoussierLabel),
                                            getter: this.getPoursuivre,
                                            subComponents: [
                                                {
                                                    name: 'poursuivre OUI',
                                                    tester: a => a,
                                                    descriptor: [{
                                                        renderer: this.renderConditionsSAVFournisseur,
                                                        getter: this.getFournisseur,
                                                        subComponents: [
                                                            {
                                                                name: 'fournisseur connu + SAV non assure par Foussier',
                                                                tester: a => a && !a.savByFoussier,
                                                                descriptor: this.finalisationSAVDescriptor
                                                            },
                                                            {
                                                                name: 'fournisseur connu + SAV assure par Foussier',
                                                                tester: a => a && a.savByFoussier,
                                                                descriptor: this.procedureSAVByFoussierDescriptor
                                                            }
                                                        ]
                                                    }]
                                                },
                                                {
                                                    name: 'poursuivre NON',
                                                    tester: a => a === false,
                                                    descriptor: [
                                                        {
                                                            name: "Proposition achat",
                                                            renderer: this.renderPropositionAchat,
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    name: 'SeuilRentabiliteReparationAtteint : OUI',
                                    tester: a => a,
                                    descriptor: [{
                                        renderer: this.renderConditionsSAVFournisseur,
                                        getter: this.getFournisseur,
                                        subComponents: [
                                            {
                                                name: 'SeuilRentabiliteReparationAtteint : OUI, NON savByFoussier',
                                                tester: a => a && !a.savByFoussier,
                                                descriptor: this.finalisationSAVDescriptor
                                            },
                                            {
                                                name: 'SeuilRentabiliteReparationAtteint : OUI, savByFoussier',
                                                tester: a => a && a.savByFoussier,
                                                descriptor: this.procedureSAVByFoussierDescriptor
                                            }
                                        ]
                                    }]
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'achat foussier avec pièce',
                    tester: a => a.numeroPiece !== '' && a.pieceGestionLignesLoaded,
                    descriptor: [
                        {
                            name: 'affichage sélection des lignes',
                            renderer: this.renderLigneGestionQualification,
                            getter: () => this.props.reclamation.lignes.length,
                            subComponents: [
                                {
                                    name: 'ZéroLigne',
                                    tester: a => a === 0, descriptor: { renderer: this.renderWarningZeroLigne }
                                },
                                {
                                    name: 'trop de lignes',
                                    tester: a => a > 1, descriptor: { renderer: this.renderWarningNbLignes }
                                },
                                {
                                    name: '1 ligne OK',
                                    tester: a => a === 1,
                                    descriptor: [
                                        {
                                            name: 'Demande état du produit',
                                            renderer: this.renderEtatProduit,
                                            getter: () => {
                                                return {
                                                    etatProduit: this.getEtatProduit(),
                                                    livraisonDirecte: this.props.livraisonDirecte,
                                                    rapido: this.props.rapido,
                                                    marqueExclusive: this.props.reclamation.lignes[0].marqueExclusive,
                                                    savByFoussier: this.props.reclamation.lignes[0].fournisseur.infosSAV.savByFoussier,
                                                    infosGarantie: this.getInfosGarantie()
                                                }
                                            },

                                            subComponents: [
                                                {
                                                    name: 'Le produit est neuf, non monté et non utilisé.',
                                                    tester: a => a.etatProduit === 0,
                                                    descriptor: [{
                                                        getter: () => { return { livraisonDirecte: this.props.livraisonDirecte, rapido: this.props.rapido, marqueExclusive: this.props.reclamation.lignes[0].marqueExclusive } },
                                                        subComponents: [
                                                            { name: 'ni livraison directe ni rapido + marque exclusive',
                                                            tester: a => !a.livraisonDirecte && !a.rapido && a.marqueExclusive, descriptor: [{ renderer: this.renderDocumentPriseEnCharge }] },
                                                            { name: 'ni livraison directe ni rapido',
                                                            tester: a => !a.livraisonDirecte && !a.rapido, descriptor: [{ renderer: this.renderPriseConnaissancePhoto }] },
                                                            { name: 'ni livraison directe ni rapido',
                                                            tester: a => !a.livraisonDirecte && !a.rapido, descriptor: [{ renderer: this.renderDepannageDirectClient }] },
                                                        ]
                                                    }]
                                                },
                                                {
                                                    name: 'Le produit est déja utilisé ou monté, cas 1 - marqueExclusive',
                                                    tester: a => a.etatProduit === 1 && !a.livraisonDirecte && !a.rapido && a.marqueExclusive && !a.savByFoussier,
                                                   
                                                    descriptor: [{
                                                        getter: () => {
                                                            return {
                                                                source: this.getInfosGarantie().source
                                                            }
                                                        },
                                                        subComponents: [
                                                            {
                                                                name: 'source article',
                                                                tester: a => a.source === 'article',
                                                                descriptor: this.procedureSAVFoussierDescriptor
                                                            },
                                                            {
                                                                name: 'non source article',
                                                                tester: a => a.source !== 'article',
                                                                descriptor: [{ renderer: this.renderDepannageDirectClient }]
                                                            },
                                                        ]
                                                    }]

                                                },
                                                {
                                                    name: 'Le produit est déja utilisé ou monté, cas 2',
                                                    tester: a => a.etatProduit === 1 && !a.rapido && a.savByFoussier,
                                                    descriptor: this.procedureSAVByFoussierDescriptor
                                                },
                                                {
                                                    name: 'Le produit est déja utilisé ou monté, cas 3',
                                                    tester: a => a.etatProduit === 1 && !a.rapido && !a.marqueExclusive && !a.savByFoussier,
                                                    descriptor: this.procedureSAVFoussierDescriptor
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ]
                        }
                    ]
                },
            ]
        }
    ];

    nonAchatInitialFoussierDescriptor = [
        {
            name: 'nonAchatInitialFoussierDescriptor',
            renderer: this.renderGarantieProduit,
            getter: this.getGarantieProduit,
            subComponents: [
                {
                    name: 'produit sous garantie',
                    tester: a => a === 0,
                    descriptor: [
                        {
                            name: 'sousgarantie',
                            renderer: () => this.renderSeuilRentabiliteReparationAtteint(seuilRentabiliteReparationSousGarantie),
                            getter: this.getSeuilRentabiliteReparationAtteint,
                            subComponents: [
                                {
                                    name: 'seuil rentabilite non atteint',
                                    tester: a => a === false,
                                    descriptor: [{ renderer: () => (<span>Article non rentable à la remise en réparation, il ne peut pas faire l'objet d'un SAV (3)</span>) }]
                                },
                                {
                                    name: 'seuil rentabilite non atteint',
                                    tester: a => a === false,
                                    descriptor: [
                                        {
                                            renderer: this.renderPropositionAchat,
                                        }
                                    ]
                                },
                                {
                                    name: 'seuil rentabilite atteint',
                                    tester: a => a,
                                    descriptor: [{
                                        name: "non achat initial, sous garantie, seuil atteint, on continue...",
                                        renderer: this.renderConditionsSAVFournisseur,
                                        getter: this.getFournisseur,
                                        subComponents: [
                                            {
                                                name: 'fournisseur connu + SAV non assure par Foussier',
                                                tester: a => a && !a.savByFoussier,
                                                descriptor: this.finalisationSAVDescriptor
                                            },
                                            {
                                                name: 'fournisseur connu + SAV assure par Foussier',
                                                tester: a => a && a.savByFoussier,
                                                descriptor: this.procedureSAVByFoussierDescriptor
                                            }
                                        ]
                                    }]
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'produit hors garantie',
                    tester: a => a === 1,
                    descriptor: [
                        {
                            name: 'horsgarantie majoration',
                            renderer: this.renderMajorationHorsGarantie,
                        },
                        {
                            name: 'horsgarantie',
                            renderer: () => this.renderSeuilRentabiliteReparationAtteint(seuilRentabiliteReparationHorsGarantie),
                            getter: this.getSeuilRentabiliteReparationAtteint,
                            subComponents: [
                                {
                                    name: 'seuil rentabilite non atteint',
                                    tester: a => a === false,
                                    descriptor: [
                                        {
                                            name: "poursuite SAV hors garantie non achat initial foussier",
                                            renderer: () => this.renderPoursuivre(poursuivreHorsGarantieNonAchatFoussierLabel),
                                            getter: this.getPoursuivre,
                                            subComponents: [
                                                {
                                                    name: 'poursuivre OUI',
                                                    tester: a => a,
                                                    descriptor: [{
                                                        renderer: this.renderConditionsSAVFournisseur,
                                                        getter: this.getFournisseur,
                                                        subComponents: [
                                                            {
                                                                name: 'fournisseur connu + SAV non assure par Foussier',
                                                                tester: a => a && !a.savByFoussier,
                                                                descriptor: this.finalisationSAVDescriptor
                                                            },
                                                            {
                                                                name: 'fournisseur connu + SAV assure par Foussier',
                                                                tester: a => a && a.savByFoussier,
                                                                descriptor: this.procedureSAVByFoussierDescriptor
                                                            }
                                                        ]
                                                    }]
                                                },
                                                {
                                                    name: 'poursuivre NON',
                                                    tester: a => a === false,
                                                    descriptor: [
                                                        {
                                                            name: "Proposition achat",
                                                            renderer: this.renderPropositionAchat,
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    name: 'seuil rentabilite atteint',
                                    tester: a => a,
                                    descriptor: [{
                                        renderer: this.renderConditionsSAVFournisseur,
                                        getter: this.getFournisseur,
                                        subComponents: [
                                            {
                                                name: 'fournisseur connu + SAV non assure par Foussier',
                                                tester: a => a && !a.savByFoussier,
                                                descriptor: this.finalisationSAVDescriptor
                                            },
                                            {
                                                name: 'fournisseur connu + SAV assure par Foussier',
                                                tester: a => a && a.savByFoussier,
                                                descriptor: this.procedureSAVByFoussierDescriptor
                                            }
                                        ]
                                    }]
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    ];


    mainDescriptor = [
        {
            name: 'header',
            renderer: this.renderHeader,
        },
        {
            name: 'Question achat initial',
            renderer: this.renderAchatInitialFoussier,
            getter: this.getAchatInitialFoussier,
            subComponents: [
                {
                    name: 'Réponse achat initial OUI',
                    tester: a => a,
                    descriptor: this.achatInitialFoussierDescriptor
                },
                {
                    name: 'Réponse achat initial NON',
                    tester: a => a === false,
                    descriptor: this.nonAchatInitialFoussierDescriptor
                }
            ]
        }
    ];


    render() {
        const { components, logTree } = qualificationHelper.getComponentsWithTrace(this.mainDescriptor);

        logTree('DefautProduitSAVAutoriseStep');

        return components;
    }
}

DefautProduitSAVAutoriseStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    rapido: PropTypes.bool.isRequired,
    livraisonDirecte: PropTypes.bool.isRequired,
    enlevementMagasin: PropTypes.bool.isRequired,
    closeAddReclamationDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(DefautProduitSAVAutoriseStep);
